<template>
  <div
    class="bread-crumb relative"
    ref="breadCrumb"
    v-loading.body.lock="isLoading"
    :element-loading-text="`${$t('lineManager.lineLoading')}...`"
  >
    <div class="wrap" v-if="produceLine.length">
      <div class="add-produce-line flex" v-if="!previewInfo.isPreview">
        <div class="relative">
          <a-button id="equipment_addLine_btn" @click="addNewLine"
            ><a-icon type="save" />{{ $t('lineManager.add') }}</a-button
          >
          <a-button
            id="equipment_trail_btn"
            @click="handleGoGuiguiTrail"
            class="ml20"
            style="width: 120px"
            v-if="isQT"
            ><span
              id="span_lng32a5fy6"
              class="block ellipsis w100"
              :title="translateLang('historyPage.trailProduction.title')"
              >{{ $t('historyPage.trailProduction.title') }}</span
            ></a-button
          >
          <span
            id="span_lo01blmpk4"
            class="trail-mark absolute color-f fs12 br4 align-center"
            v-if="isQT"
            >{{ $t('historyPage.trailProduction.start') }}</span
          >
        </div>
        <div class="lock-icon" id="lock_icon_btn" @click="handleOpenUnlock">
          <a-icon
            type="lock"
            theme="filled"
            style="color: #18a8c7"
            id="equipment_lock_icon_btn"
            v-if="tempStatus === 1 || tempStatus === 3"
          />
          <a-icon
            id="equipment_unlock_icon_btn"
            type="unlock"
            theme="filled"
            style="color: #898989"
            v-else
          />
        </div>
      </div>
      <!-- line_item produceLine是生产线数据 -->
      <div
        class="produce-line"
        v-for="(line_item, line_index) in produceLine"
        :key="line_index + '2'"
      >
        <div>
          <div class="produce-setting">
            <span
              class="line-name"
              v-if="nowLine != line_index"
              :id="`equipment_line_${line_index}_name`"
              >{{ line_item.name }}</span
            >
            <a-input
              ref="line_name"
              v-model="line_item.name"
              @pressEnter="confirmLineName(line_item, line_index)"
              @blur.native="confirmLineName(line_item, line_index)"
              :id="`equipment_line_${line_index}_rename_input`"
              v-else
            ></a-input>
            <div class="produce-line-icon" v-if="!previewInfo.isPreview">
              <!-- 重命名 -->
              <!-- v-if="line_index != 0" -->
              <a-button
                @click="modifyLineName(line_item, line_index)"
                :id="`equipment_line_${line_index}_rename_btn`"
                >{{ $t('common.reName') }}</a-button
              >
              <!-- 删除 -->
              <a-button
                :id="`equipment_line_${line_index}_delete_btn`"
                @click="deleteLine(line_item)"
                v-if="line_index != 0"
                >{{ $t('common.delete') }}</a-button
              >
              <!-- 保存 -->
              <a-button
                :id="`equipment_line_${line_index}_save_btn`"
                @click="saveLine(line_item, line_index)"
                ><a-icon type="save" style="margin-right: 0" />{{
                  $t('common.save')
                }}</a-button
              >
            </div>
            <div class="produce-line-icon" v-if="previewInfo.isApply">
              <a-button
                :id="`equipment_line_${line_index}_save_btn`"
                @click="saveLine(line_item, line_index)"
                ><a-icon
                  type="save"
                  style="margin-right: 0"
                />应用孔槽分流</a-button
              >
            </div>
          </div>
          <!-- line_item 为一条生产线 -->
          <div class="content">
            <div>
              <div
                v-for="(cut_item, cut_index) in line_item.cutList"
                :key="cut_index + '3'"
              >
                <div class="cutting common-setting" v-if="cut_item.show">
                  <span id="span_dk9hxttr8z" class="common-setting-title">{{
                    $t('lineManager.engraving')
                  }}</span>
                  <a-icon
                    type="left"
                    :id="`equipment_line_${line_index}_pre_btn`"
                    @click="
                      changeNowLineSetting(
                        line_item,
                        cut_item.index,
                        'last',
                        'cut',
                        line_index
                      )
                    "
                  />
                  <div
                    class="common-content"
                    @click="gotoSetting(cut_item, line_item)"
                    :id="`equipment_line_${line_index}_toSetting_btn`"
                  >
                    <div>
                      <img :src="require('../../' + cut_item.img)" alt="" />
                    </div>
                    <span :id="`equipment_line_${line_index}_cut_name`">{{
                      translateLang(cut_item.name)
                    }}</span>
                  </div>
                  <a-icon
                    type="right"
                    :id="`equipment_line_${line_index}_next_btn`"
                    @click="
                      changeNowLineSetting(
                        line_item,
                        cut_item.index,
                        'next',
                        'cut',
                        line_index
                      )
                    "
                  />
                </div>
              </div>
              <div
                v-for="(cure_item, cure_index) in line_item.cureList"
                :key="cure_index + '4'"
              >
                <div
                  class="holes-equipment common-setting"
                  v-if="
                    cure_item.recombination &&
                    line_item.activeCutEquip !== 'glassEquip'
                  "
                >
                  <span id="span_lh3j4ht5jw" class="common-setting-title">{{
                    $t('lineManager.holeSlotEquip')
                  }}</span>
                  <a-icon
                    type="left"
                    :id="`equipment_line_${line_index}_holeSlot_pre_btn`"
                    @click="
                      changeNowLineSetting(
                        line_item,
                        cure_item.index,
                        'last',
                        'cure',
                        line_index
                      )
                    "
                  />
                  <div
                    class="common-content"
                    :id="`equipment_line_${line_index}_holeSlot_toSetting_btn`"
                    @click="gotoSetting(cure_item, line_item)"
                  >
                    <div>
                      <img
                        :src="
                          line_item.haveSetted
                            ? require('../../' + cure_item.img)
                            : require('@/assets/icon/noSetted.svg')
                        "
                        alt=""
                      />
                    </div>
                    <span :id="`equipment_line_${line_index}_holeSlot_name`">{{
                      line_item.haveSetted
                        ? translateLang(cure_item.name)
                        : $t('lineManager.noUse')
                    }}</span>
                  </div>
                  <a-icon
                    type="right"
                    :id="`equipment_line_${line_index}_holeSlot_next_btn`"
                    @click="
                      changeNowLineSetting(
                        line_item,
                        cure_item.index,
                        'next',
                        'cure',
                        line_index
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 当前设备不是组合设备和玻璃切割机 -->
          <div
            class="cutting-setting"
            v-if="
              line_item.showExtraSetting &&
              !line_item.showCombinationSetting &&
              line_item.activeCutEquip !== 'glassEquip'
              // &&
              // !line_item.cureList.find((i) => i.value == 'side').show
            "
          >
            <div
              :id="`equipment_line_${line_index}_engraving_setting_btn`"
              class="cutting-setting-title"
              @click="cureSetting(line_item)"
            >
              <a-icon
                :type="line_item.showCure ? 'caret-down' : 'caret-right'"
              />
              <span id="span_r4ieorgsu9">{{
                $t('lineManager.workSetting')
              }}</span>
            </div>
            <div class="cutting-checkbox" v-if="line_item.showCure">
              <div id="div_r5hkvi8b4v" class="tip mb16">
                {{ $t('lineManager.warningTip') }}
              </div>
              <m-setting-options
                :isAioAndDock56HoleSlotShuntAuth="
                  isAioAndDock56HoleSlotShuntAuth
                "
                :isShowCuttingMachineSettings="true"
                :isShowFiveSixSettings="
                  line_item.nowCure != 'doubleHoleSlot' &&
                  userInfo.edition_id != 4 &&
                  isShowHoleShunt(line_item) &&
                  line_item.activeCureEquip == 'fiveSix'
                "
                :isShowSideHoleSettings="
                  line_item.activeCureEquip === 'side' &&
                  line_item.activeCutEquip === 'engraving'
                "
                :line_item="produceLine[line_index]"
                :line_index="line_index"
                @changeWay="handleChangeWay"
              ></m-setting-options>
            </div>
          </div>
          <!-- 组合设备 -->
          <div
            :id="`equipment_line_${line_index}_combination_setting_btn`"
            class="combination_setting"
            v-if="line_item.showCombinationSetting"
          >
            <div
              class="combination_setting_title"
              @click="combinSeting(line_item)"
            >
              <a-icon
                :type="line_item.showCombin ? 'caret-down' : 'caret-right'"
              />
              <span id="span_vnl8ac0nh3">{{
                $t('lineManager.combinSetting')
              }}</span>
            </div>
            <!-- 组合设备展示 定制用户单独展示 -->
            <div
              class="combination_setting_box"
              v-if="
                line_item.showCombin &&
                !isSpecialUserCombinedDevice &&
                !isSpecialUserDoorWallCabinet
              "
            >
              <div class="choose_equipment_box">
                <div>
                  <div id="div_y0ixkln5y2" class="tip mb16">
                    {{ $t('lineManager.warningTip') }}
                  </div>
                  <div>
                    <div class="choose_equipment">
                      <div>
                        <span id="span_cjaql9uncz"
                          >{{ $t('lineManager.equipment1') }}：</span
                        >
                        <a-select
                          style="width: 160px"
                          v-model="
                            line_item.combinationEquip_settings.firstEquipment
                          "
                        >
                          <a-select-option
                            :value="com_item.value"
                            v-for="(com_item, com_index) in com_equipments"
                            :key="com_index"
                            :disabled="
                              line_item.combinationEquip_settings
                                .secondEquipment == com_item.value ||
                              (line_item.combinationEquip_settings
                                .secondEquipment == 'engraving' &&
                                com_item.value == 'sideHoleDrill') ||
                              (line_item.combinationEquip_settings
                                .secondEquipment == 'sideHoleDrill' &&
                                com_item.value == 'engraving') ||
                              (line_item.activeCutEquip == 'saw' &&
                                com_item.value == 'engraving')
                            "
                          >
                            {{ $t(com_item.name) }}
                          </a-select-option>
                        </a-select>
                        <span
                          id="span_bt8jlyrrlz"
                          class="choose_equipment_setting_btn"
                          @click="
                            toSetting(
                              line_item.combinationEquip_settings
                                .firstEquipment,
                              line_item
                            )
                          "
                          >{{ $t('main.head.setting') }}</span
                        >
                      </div>
                      <div>
                        <span
                          ><i
                            class="iconfont icon-add"
                            style="margin-left: 12px"
                          ></i
                        ></span>
                        <i
                          class="el-icon-sort"
                          style="
                            font-size: 16px;
                            color: #18a8c7;
                            cursor: pointer;
                            margin-left: 203px;
                          "
                          @click="changComEquipment(line_item)"
                        ></i>
                      </div>
                      <div>
                        <span id="span_q6oirxslgs"
                          >{{ $t('lineManager.equipment2') }}：</span
                        >
                        <a-select
                          style="width: 160px"
                          v-model="
                            line_item.combinationEquip_settings.secondEquipment
                          "
                        >
                          <a-select-option
                            :value="com_item.value"
                            v-for="(com_item, com_index) in com_equipments"
                            :key="com_index"
                            :disabled="
                              line_item.combinationEquip_settings
                                .firstEquipment == com_item.value ||
                              (line_item.combinationEquip_settings
                                .firstEquipment == 'engraving' &&
                                com_item.value == 'sideHoleDrill') ||
                              (line_item.combinationEquip_settings
                                .firstEquipment == 'sideHoleDrill' &&
                                com_item.value == 'engraving') ||
                              (line_item.activeCutEquip == 'saw' &&
                                com_item.value == 'engraving')
                            "
                          >
                            {{ translateLang(com_item.name) }}
                          </a-select-option>
                        </a-select>
                        <span
                          id="span_p4otqbacbs"
                          class="choose_equipment_setting_btn"
                          @click="
                            toSetting(
                              line_item.combinationEquip_settings
                                .secondEquipment,
                              line_item
                            )
                          "
                          >{{ $t('main.head.setting') }}</span
                        >
                      </div>
                    </div>
                    <div id="div_iqfsowbv66" class="choose_equipment_msg">
                      {{ $t('lineManager.noSameTip') }}
                    </div>
                  </div>
                </div>
                <div class="guidance-prompt">
                  <div class="flex flex-cross--center">
                    <img src="@/assets/image/service.png" class="service-img" />
                    <span id="span_pq0s8tuleu" class="ml8 fs16 color-o-9">
                      {{
                        translateUniform('支持定制化服务，打造您的专属生产方案')
                      }}</span
                    >
                  </div>
                  <div class="mv14 flex">
                    <span id="span_ima9dc3zcm">{{
                      translateUniform('例：')
                    }}</span>
                    <div class="example">
                      <span id="span_ufjz9fwrdw">
                        {{
                          translateUniform('雕刻机+五/六面钻+侧孔机组合')
                        }}</span
                      >
                      <span id="span_1n5fwx07wv" class="mv4">{{
                        translateUniform('电子锯+五/六面钻+侧孔机组合')
                      }}</span>
                      <span id="span_nqeqyqh8mx">{{
                        translateUniform('全自动一体生产线+五/六面钻组合')
                      }}</span>
                    </div>
                  </div>
                  <div class="flex flex-cross--center">
                    <img src="@/assets/image/consult.png" class="service-img" />
                    <span id="span_orvu0f7fs1" class="ml8 fs16 color-o-9">
                      {{
                        translateUniform(
                          '可以直接向您的柜柜软件销售或售后人员反馈您的需求'
                        )
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="equipment_setting">
                <div id="div_b7863g39ep" class="equipment_setting_title">
                  {{ $t('lineManager.workRange') }}
                </div>
                <div class="holes_slots_setting">
                  <a-checkbox
                    id="a_checkbox_pe7iesotyb"
                    v-model="
                      line_item.combinationEquip_settings.specialHoles.enable
                    "
                    >{{ $t('lineManager.singleHole') }}</a-checkbox
                  >
                  <div>
                    <span id="span_mvr3fyldhq"
                      >{{ $t('lineManager.diameterRange') }}：</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialHoles.enable
                      "
                      :min="0"
                      v-model="
                        line_item.combinationEquip_settings.specialHoles
                          .minDiameter
                      "
                    />
                    <span
                      id="span_xgronfnqgd"
                      style="display: inline-block; padding: 0 5px; color: #999"
                      >{{ $t('lineManager.to') }}</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialHoles.enable
                      "
                      :min="0"
                      ref="maxHolesWidth"
                      v-model="
                        line_item.combinationEquip_settings.specialHoles
                          .maxDiameter
                      "
                    />
                  </div>
                  <div>
                    <span id="span_22okyt6ebe"
                      >{{ $t('lineManager.hDeepRange') }}：</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialHoles.enable
                      "
                      :min="0"
                      v-model="
                        line_item.combinationEquip_settings.specialHoles
                          .minDepth
                      "
                    />
                    <span
                      id="span_wq2q79jovy"
                      style="display: inline-block; padding: 0 5px; color: #999"
                      >{{ $t('lineManager.to') }}</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialHoles.enable
                      "
                      :min="0"
                      ref="maxHolesDepth"
                      v-model="
                        line_item.combinationEquip_settings.specialHoles
                          .maxDepth
                      "
                    />
                  </div>
                </div>
                <div class="holes_slots_setting">
                  <a-checkbox
                    id="a_checkbox_lrlx9003ck"
                    v-model="
                      line_item.combinationEquip_settings.specialSlots.enable
                    "
                    >{{ $t('lineManager.singleSlot') }}</a-checkbox
                  >
                  <div>
                    <span id="span_5qb0mejkyu"
                      >{{ $t('lineManager.widthRange') }}：</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialSlots.enable
                      "
                      :min="0"
                      v-model="
                        line_item.combinationEquip_settings.specialSlots
                          .minWidth
                      "
                    />
                    <span
                      id="span_1gzc6rqix8"
                      style="display: inline-block; padding: 0 5px; color: #999"
                      >{{ $t('lineManager.to') }}</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialSlots.enable
                      "
                      :min="0"
                      ref="maxSlotsWidth"
                      v-model="
                        line_item.combinationEquip_settings.specialSlots
                          .maxWidth
                      "
                    />
                  </div>
                  <div>
                    <span id="span_6piy5oeo2o"
                      >{{ $t('lineManager.sDeepRange') }}：</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialSlots.enable
                      "
                      :min="0"
                      v-model="
                        line_item.combinationEquip_settings.specialSlots
                          .minDepth
                      "
                    />
                    <span
                      id="span_47j64ew78x"
                      style="display: inline-block; padding: 0 5px; color: #999"
                      >{{ $t('lineManager.to') }}</span
                    >
                    <a-input-number
                      :disabled="
                        !line_item.combinationEquip_settings.specialSlots.enable
                      "
                      :min="0"
                      ref="maxSlotsDepth"
                      v-model="
                        line_item.combinationEquip_settings.specialSlots
                          .maxDepth
                      "
                    />
                  </div>
                </div>
                <div id="div_kj9xzwt731" class="choose_equipment_msg">
                  {{ $t('lineManager.rangeWarning') }}
                </div>
              </div>
            </div>
            <!-- 定制用户展示界面 使用flexbox的order属性控制元素的排列顺序 -->
            <div
              v-else-if="
                line_item.showCombin &&
                (isSpecialUserCombinedDevice || isSpecialUserDoorWallCabinet)
              "
              class="cutting-checkbox"
            >
              <div id="div_og4zggi9wm" class="tip mb16">
                {{ $t('lineManager.warningTip') }}
              </div>
              <!-- 开料设备选择 -->
              <div class="flex mb15 flex-cross--center">
                <!-- 取消掉开料设备 -->
                <!-- <div class="mr10">
                  <span>{{ $t('lineManager.engraving') }}：</span>
                  <a-select
                    style="width: 160px"
                    v-model="line_item.combinationEquip_settings.firstEquipment"
                    @change="handleChangeEquipment(line_item)"
                  >
                    <a-select-option value="engraving">
                      {{ $t('common.engraving') }}
                    </a-select-option>
                    <a-select-option value="electronicSaw">{{
                      $t('common.electronicSaw')
                    }}</a-select-option> </a-select
                  ><span
                    class="choose_equipment_setting_btn"
                    @click="
                      toSetting(line.combinationEquip.firstEquipment, line_item)
                    "
                    >{{ $t('main.head.setting') }}</span
                  >
                </div>
                <span class="mh10">+</span> -->
                <div class="mr10">
                  <span id="span_f697dx7mbp"
                    >{{ $t('common.holeEquipment', { num: 1 }) }}：</span
                  >
                  <a-select
                    style="width: 160px"
                    v-model="line_item.combinationEquip_settings.firstEquipment"
                  >
                    <a-select-option
                      :value="equipment.value"
                      v-for="equipment in combinedEquipments"
                      :key="equipment.value"
                      :disabled="
                        isSecondEquipmentDisabled(equipment.value, line_item)
                      "
                    >
                      {{ $t(equipment.label) }}
                    </a-select-option>
                  </a-select>
                  <span
                    id="span_rveofzz73p"
                    class="choose_equipment_setting_btn"
                    @click="
                      toSetting(
                        line_item.combinationEquip_settings.firstEquipment,
                        line_item
                      )
                    "
                    >{{ $t('main.head.setting') }}</span
                  >
                </div>
                <span>
                  <i
                    class="el-icon-sort"
                    style="
                      font-size: 16px;
                      color: #18a8c7;
                      cursor: pointer;
                      margin-left: 10px;
                      margin-right: 10px;
                      transform: rotate(90deg);
                    "
                    @click="changComEquipment(line_item)"
                  ></i>
                </span>
                <div class="mr10">
                  <span id="span_8bwxwdrrap"
                    >{{ $t('common.holeEquipment', { num: 2 }) }}：</span
                  >
                  <a-select
                    style="width: 160px"
                    v-model="
                      line_item.combinationEquip_settings.secondEquipment
                    "
                    :disabled="
                      !line_item.combinationEquip_settings.firstEquipment
                    "
                  >
                    <a-select-option
                      :value="equipment.value"
                      v-for="equipment in combinedEquipments"
                      :key="equipment.value"
                      :disabled="
                        isThirdEquipmentDisabled(equipment.value, line_item)
                      "
                    >
                      {{ $t(equipment.label) }}
                    </a-select-option>
                  </a-select>
                  <span
                    id="span_1fy8oi7jg5"
                    class="choose_equipment_setting_btn"
                    @click="
                      toSetting(
                        line_item.combinationEquip_settings.secondEquipment,
                        line_item
                      )
                    "
                    >{{ $t('main.head.setting') }}</span
                  >
                </div>
              </div>
              <!-- 启用电子锯之后特殊孔槽展示侧孔机的 -->
              <m-setting-options
                :isAioAndDock56HoleSlotShuntAuth="
                  isAioAndDock56HoleSlotShuntAuth
                "
                :isShowCuttingMachineSettings="
                  isShowCuttingMachineSettings(line_item)
                "
                :isShowFiveSixSettings="isShowFiveSixSettings(line_item)"
                :isShowSideHoleSettings="isShowSideHoleSettings(line_item)"
                :isShowIntegrateDoorWallCabinetSettings="
                  isShowIntegrateDoorWallCabinetSettings(line_item)
                "
                :isShowHoleSlot="isShowHoleSlot(line_item)"
                :isShowCombinedFiveSix="isShowCombinedFiveSix(line_item)"
                :isShowCombinedPTP="isShowCombinedPTP(line_item)"
                :isShowCombinedSideHole="isShowCombinedSideHole(line_item)"
                :line_item="produceLine[line_index]"
                :line_index="line_index"
                :orderEquipment="
                  line_item.combinationEquip_settings.firstEquipment
                "
                @changeWay="handleChangeWay"
              ></m-setting-options>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h100 flex flex-cross--center flex-main--center">
      <a-empty style="height: 150px"></a-empty>
    </div>
    <g-base-modal
      :visible="showDeleteConfirm"
      v-if="showDeleteConfirm"
      @ok="confirmDelete"
      @cancel="showDeleteConfirm = false"
      :contain="$t('lineManager.deleteWarning')"
    >
    </g-base-modal>
    <div class="back" ref="back" @click="scrollWarp(true)">
      <a-icon type="arrow-up" />
      <span id="span_1sql3dq70u">{{ $t('lineManager.top') }}</span>
    </div>
    <m-lock-modal
      :visible.sync="isShowVisible"
      :status.sync="lockStatus"
      :tempStatus.sync="tempStatus"
      :verifyPassword="verifyPassword"
      :lineName="currentItem?.name"
      :codeType="codeType"
      @getLockPassword="handleGetLockPassword"
      @handleChangePasswordState="handleChangePasswordState"
      @update:codeType="codeType = $event"
    ></m-lock-modal>
    <g-base-modal
      v-if="isVisiblExpire"
      :visible="isVisiblExpire"
      :okText="$t('common.ok')"
      :cancelText="$t('common.cancel')"
      :contain="$t('common.annualFeeExpired')"
      @ok="() => (isVisiblExpire = false)"
      @cancel="() => (isVisiblExpire = false)"
    >
    </g-base-modal>
  </div>
</template>

<script>
import { fetchUserPermission } from '@/apis/auth'
import { getEquipmentPermission } from '@/apis/equipment'
import { getJsonUrlData } from '@/apis/equipment'
import { getLockStatus } from '@/apis/productionLineLock'
import GQrcodeAuthentication from '@/components/g-QRcode-authentication/index.vue'
import GBaseModal from '@/components/g-base-modal.vue'
import SearchRegistry, { Navigate } from '@/components/g-search/utils'
import { translateLang as translateUniform } from '@/data/i18n/translateLang'
import store from '@/store'
import { isWechatQrAuthAreaCode } from '@/util/area_code'
import { translate } from '@/util/commonFun'
import { buryPointApi, genFinalRecord } from '@/util/commonFuncs'
import {
  genUniId,
  thirdPermission,
  verifyInputNumber,
} from '@/util/commonFuncs.js'
import { operateRecordTableType } from '@/util/configure'
import { webId } from '@/util/configure'
import { equipmentFormTextObj } from '@/util/operateRecordConfigure/equipmentConfigure'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import MLockModal from '@/views/equipment/component/m-lock-modal.vue'
import MSettingOptions from '@/views/equipment/component/m-setting-options.vue'
import { cloneDeep } from 'lodash'
import { mapMutations, mapState } from 'vuex'

const keyName = {
  special_hole_slot: {
    HINGESCREW: '铰链孔',
    HINGE: '铰链孔',
    HANGER: '衣通孔',
    STRENTCH: '拉直器槽',
    BP: '背板槽',
    ALS: '暗拉手槽',
    METAL: '门板金属条槽',
    DMBS: '抽屉金属条槽',
    in_range_all: '允许短边尺寸',
    KUCHOU: '裤抽孔',
    YXJ: '隐形件',
    LKYXJ: '乐扣槽',
    holes_in_yixing: '异形板上所有孔',
    slots_in_yixing: '异形板所有槽',
    bull_horn_handle: '牛角拉手',
    lightSlot: '灯槽',
    haitang_corner: '海棠角',
    range_list: '允许短边尺寸',
    hole_slot_in_free_yixing: '自由异形板上所有孔槽',
  },
  special_hole_slot_way: {
    HINGESCREW: '铰链孔',
    HINGE: '铰链孔',
    HANGER: '衣通孔',
    STRENTCH: '拉直器槽',
    BP: '背板槽',
    ALS: '暗拉手槽',
    METAL: '门板金属条槽',
    DMBS: '抽屉金属条槽',
    in_range_all: '允许短边尺寸',
    KUCHOU: '裤抽孔',
    YXJ: '隐形件',
    LKYXJ: '乐扣槽',
    holes_in_yixing: '异形板上所有孔',
    slots_in_yixing: '异形板所有槽',
    bull_horn_handle: '牛角拉手',
    lightSlot: '灯槽',
    hole_slot_in_free_yixing: '自由异形板上所有孔槽',
  },
  engraving_process_setting: {
    allow_turn_plate_process: 'lineManager.specialHS',
    dock56_drill_still_process: 'lineManager.engravingCuted',
    non_hole_slot_of_special_shape: 'lineManager.engravingPath',
    short_edge_range: 'lineManager.maxShortSize',
    long_edge_range: 'lineManager.maxLongSize',
    curve_range: 'lineManager.curve_range',
    special_shape_processing_in_dock56: 'lineManager.engravingCutedSpecial',
  },
}
// 定制用户且门墙柜一体机设备
// const customizedUserIdsDoorWall = [68074, 998042]
// 组合设备可选择设备
// const combinedEquipments = [
//   {
//     value: 'sideHoleDrill',
//     label: 'common.sideHoleDrill',
//   },
//   {
//     value: 'dock56FDrill',
//     label: 'common.FSDrill',
//   },
//   // 此次先不做ptp，后续可能会做
//   // {
//   //   value: 'ptpHoleDrill',
//   //   label: 'common.PTP',
//   // },
//   {
//     value: 'door_wall_aio',
//     label: '门墙柜一体机',
//   },
// ]
const equipmentObj = {
  engraving: 'engraving',
  saw: 'electronicSaw',
}
const authVersionIds = [5, 6, 14, 19]
export default {
  computed: {
    ...mapState('equipEnvironment', ['previewProductLine', 'previewInfo']),
    combinedEquipments() {
      if (this.isSpecialUserDoorWallCabinet) {
        return [
          {
            value: 'dock56FDrill',
            label: 'common.FSDrill',
          },

          {
            value: 'door_wall_aio',
            label: 'doorWallCabinet.title',
          },
        ]
      } else if (this.isSpecialUserCombinedDevice) {
        return [
          {
            value: 'sideHoleDrill',
            label: 'common.sideHoleDrill',
          },
          {
            value: 'dock56FDrill',
            label: 'common.FSDrill',
          },
          // 此次先不做ptp，后续可能会做
          // {
          //   value: 'ptpHoleDrill',
          //   label: 'common.PTP',
        ]
      }
    },
    isUseQrCodeAuth() {
      // 使用二维码鉴权：非第三方/老板良，且区号为中国大陆及港澳台
      return (
        !(
          sessionStorage.getItem('thinkerx_material') ||
          sessionStorage.getItem('material_cache_data')
        ) && isWechatQrAuthAreaCode(sessionStorage.getItem('area_code'))
      )
    },
    canEdit() {
      return (lists, value) => {
        return !lists.includes(value)
      }
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    isAddNewLine() {
      let flag = false
      switch (this.userInfo.edition_id) {
        case 5:
          flag = true
          break
        case 6:
          flag = true
          break
        case 12:
          if (this.produceLine.length < 4) {
            flag = true
          }
          break
      }
      return flag
    },
    dealKeyName() {
      return (obj, key) => {
        return keyName[obj][key] ? translate(keyName[obj][key]) : 'error'
      }
    },
    isShowHoleShunt() {
      return (lineItem) => {
        const d = lineItem.cureList.some(
          (item) =>
            item.show && (item.value == 'fiveSix' || item.value == 'ptp')
        )
        return d
      }
    },
    // 组合设备的条件显示
    // 是否显示开料机设置
    isShowCuttingMachineSettings() {
      return (line_item) => {
        return line_item.activeCutEquip === 'engraving'
      }
    },
    // 是否显示五六面钻设置
    isShowFiveSixSettings() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          line_item.activeCutEquip !== 'electronicSaw' &&
          (firstEquipment === 'dock56FDrill' ||
            secondEquipment === 'dock56FDrill')
        )
      }
    },
    // 是否显示侧孔机设置
    isShowSideHoleSettings() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          firstEquipment === 'sideHoleDrill' ||
          secondEquipment === 'sideHoleDrill'
        )
      }
    },
    isShowIntegrateDoorWallCabinetSettings() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          firstEquipment === 'door_wall_aio' ||
          secondEquipment === 'door_wall_aio'
        )
      }
    },
    // 加工方式选择 当只选择雕刻机或者打孔设备只选择侧孔机的时候 加工方式置灰（除了加工正反面孔槽）
    // 在开启组合设备的情况下
    isShowHoleSlot() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          line_item.activeCureEquip == 'combination' &&
          (!firstEquipment || // 打孔设备1为空
            (firstEquipment === 'sideHoleDrill' && !secondEquipment)) // 打孔设备选择侧孔机且没有第二个打孔设备
        )
      }
    },
    // 组合设备选择了五/六面钻
    isShowCombinedFiveSix() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          line_item.activeCureEquip == 'combination' &&
          (firstEquipment === 'dock56FDrill' ||
            secondEquipment === 'dock56FDrill')
        )
      }
    },
    // 组合设备选择了ptp
    isShowCombinedPTP() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          line_item.activeCureEquip == 'combination' &&
          (firstEquipment === 'ptpHoleDrill' ||
            secondEquipment === 'ptpHoleDrill')
        )
      }
    },
    // 组合设备选择了侧孔机
    isShowCombinedSideHole() {
      return (line_item) => {
        const { firstEquipment, secondEquipment } =
          line_item.combinationEquip_settings
        return (
          line_item.activeCureEquip == 'combination' &&
          (firstEquipment === 'sideHoleDrill' ||
            secondEquipment === 'sideHoleDrill')
        )
      }
    },
    isSpecialUserCombinedDevice() {
      return this.$store.state.userPermissions['customized_combined_device']
    },
    isSpecialUserDoorWallCabinet() {
      return this.$store.state.userPermissions['door_wall_aio']
    },
  },
  data() {
    return {
      verifyPassword: false,
      isShowVisible: false,
      codeType: 'bluen_update_production',
      lockStatus: 1, // 锁状态
      tempStatus: 1, //默认状态
      operateType: 'save',
      initLockStatus: 0,
      isShowToast: false,
      showPageLoading: false,
      com_equipments: [
        {
          value: 'dock56FDrill',
          name: 'common.FSDrill',
        },
        {
          value: 'engraving',
          name: 'common.engraving2',
        },
        {
          value: 'sideHoleDrill',
          name: 'common.sideHoleDrill',
        },
        {
          value: 'ptpHoleDrill',
          name: 'common.PTP',
        },
      ],
      // 生产线数据
      produceLine: [],
      // 通过接口获取到的生产线原始数据
      oriProduceLine: [],
      cureCheckList: [
        {
          name: 'lineManager.onlyCut',
          value: 'noHoleSlot',
        },
        {
          name: 'lineManager.onlyFrontHoleSlot',
          value: 'frontHoleSlot',
        },
        {
          name: 'lineManager.onlyHoleSlot',
          value: 'doubleHoleSlot',
        },
      ],
      // 记录当前点击生产线
      nowLine: -1,
      // 记录当前点击的生产线数据
      currentLine: {},
      // 显示删除确认框
      showDeleteConfirm: false,
      // 记录获取到的生产线数据
      productLineList: [],
      // 记录新建的生产线编号
      lineIndex: 0,
      // 记录是否已经出发修改名字的事件, 防止失焦事件和回车事件同时触发
      isEditName: true,
      // 是否是从天工官网进入
      showTiangongPage: false,
      // 记录是否隐藏添加生产线
      showNewProBtn: true,
      // 当前选中的生产线
      currentProductLine: {},
      currentSaveLineId: '', // 当前保存生产线的id
      // 开料机设置-加工设置生成与否选项
      isDock56DrillStillProcess: 0,
      currentItem: null,
      currentLineIndex: null,

      cuttingSettingOptions: [
        {
          value: 0,
          label: 'lineManager.noGen',
          key: 'noGen',
        },
        {
          value: 1,
          label: 'lineManager.genCut',
          key: 'genCut1',
        },
        {
          value: 2,
          label: 'lineManager.genNoCut',
          key: 'genNoCut',
        },
      ],
      specialSlots: [
        {
          value: false,
          label: 'lineManager.normalSlot',
        },
        {
          value: true,
          label: 'lineManager.specialSlot',
        },
      ],
      holeSlotKeys: [
        {
          key: 'HINGESCREW',
          label: 'common.hinge',
        },
        {
          key: 'HANGER',
          label: 'common.clothole',
        },
        {
          key: 'STRENTCH',
          label: 'common.stretcher',
        },
        {
          key: 'BP',
          label: 'common.backPlank',
        },
        {
          key: 'ALS',
          label: 'common.ALS',
        },
        {
          key: 'METAL',
          label: 'common.doorSlot',
        },
        {
          key: 'DMBS',
          label: 'common.drawerSlot',
        },

        {
          key: 'KUCHOU',
          label: 'common.KC',
        },
        {
          key: 'YXJ',
          label: 'common.stealth',
        },

        {
          key: 'gratingSlot',
          label: 'common.gratingSlot',
        },
        {
          key: 'lightSlot',
          label: 'common.lightSlot',
        },
        {
          key: 'LKYXJ',
          label: 'common.lkSlot',
        },
        {
          key: 'bull_horn_handle',
          label: 'common.millInfo',
        },
        {
          key: 'haitang_corner',
          label: 'common.haiTang',
        },
        {
          key: 'holes_in_yixing',
          label: 'common.allHole',
        },
        {
          key: 'slots_in_yixing',
          label: 'common.allSlot',
        },
        {
          key: 'hole_slot_in_free_yixing',
          label: 'common.freedomAllHoleSlot',
        },
      ],
      aioHoleSlotKeys: [
        {
          key: 'ALS',
          label: 'common.ALS',
        },
        {
          key: 'BP',
          label: 'common.backPlank',
        },
        {
          key: 'METAL',
          label: 'common.doorSlot',
        },
        {
          key: 'DMBS',
          label: 'common.drawerSlot',
        },
        {
          key: 'STRENTCH',
          label: 'common.stretcher',
        },
        {
          key: 'gratingSlot',
          label: 'common.gratingSlot',
        },
      ],
      specialSettingOptions: [
        { lable: 'lineManager.onlyFrontSide', value: 'front' },
        { lable: 'lineManager.onlyBackSide', value: 'back' },
        { lable: 'lineManager.bothFrontBack', value: 'front_back' },
      ],
      rangeOptions: [
        { lable: 'lineManager.less', value: '<' },
        { lable: 'lineManager.greater', value: '>' },
        { lable: 'lineManager.equal', value: '=' },
      ],
      conditionOptions: [
        { lable: 'lineManager.and', value: 'and' },
        { lable: 'lineManager.or', value: 'or' },
      ],
      aioSpecialSettingOptions: [
        { lable: 'lineManager.onlyFrontSide', value: 'front' },
        // { lable: '仅加工反面', value: 'back' },
        // { lable: '加工正面和反面', value: 'front_back' },
      ],
      // 是否加载数据中
      isLoading: false,
      isQT: window.webToQt,
      isAio: true,
      isVisiblExpire: false,
      // customizedUserIdsDoorWall, // 组合设备定制用户id(针对门墙柜一体机设备 + 五六面钻)
      // combinedEquipments, // 组合设备选项
      authVersionIds,
      isAioAndDock56HoleSlotShuntAuth: false, // 无一体机+五六面钻分流权限时为
    }
  },
  methods: {
    async fetchAioAndDock56HoleSlotShuntAuth() {
      const res = await fetchUserPermission({
        permission_type: 'AIO_AND_DOCK56_HOLE_SLOT_SHUNT',
      })
      if (res.status === 1) {
        this.isAioAndDock56HoleSlotShuntAuth = res.data.enable
      }
    },
    ...mapMutations(['setProLineList']),
    translateLang(key) {
      return translate(key)
    },
    async handleGetLockPassword(password) {
      this.lockPassword = password
      if (this.operateType === 'save') {
        await this.saveLine(this.currentItem, this.currentLineIndex)
      } else if (this.operateType === 'delete') {
        this.confirmDelete(this.currentItem, this.currentLineIndex)
      }
    },
    handleChangePasswordState(state) {
      this.verifyPassword = state
    },
    // 验证输入框输入, 新增需求长边限制允许输入为空，兼容其他使用地方，传入默认参数
    verifyInput(
      val,
      obj,
      keys,
      rule,
      isMinus = false,
      min = 0,
      isEmpty = false
    ) {
      verifyInputNumber(val, obj, keys, rule, isMinus, min, isEmpty)
    },
    changComEquipment(line) {
      let str = line.combinationEquip_settings.firstEquipment
      line.combinationEquip_settings.firstEquipment =
        line.combinationEquip_settings.secondEquipment
      line.combinationEquip_settings.secondEquipment = str
    },
    toSetting(val, line) {
      if (!val) {
        return this.$message.error('lineManager.selectEquipmentType')
      }
      let path = ''
      switch (val) {
        case 'dock56FDrill':
          path = 'dockFiveSix'
          break
        case 'engraving':
          path = 'engraving'
          break
        case 'sideHoleDrill':
          path = 'sideHole'
          break
        case 'ptpHoleDrill':
          path = 'bluenPtp'
          break
        case 'electronicSaw':
          path = 'electronicSaw'
          break
        case 'door_wall_aio':
          path = 'integrateDoorWallCabinet'
          break
      }
      buryPointApi('equipment_dock', 'combination')
      if (this.previewInfo.isPreview) {
        path = `${path}-preview`
      }
      this.$router.push({
        path,
        query: {
          setting_id: line.id,
          line: line.name,
        },
      })
    },
    // 检测组合设备输入框值
    detectComValue(item) {
      let specialHoles = item.combinationEquip_settings.specialHoles
      let specialSlots = item.combinationEquip_settings.specialSlots
      let req = {
        msg: '',
        flag: false,
        ref: '',
      }
      if (specialHoles.enable) {
        if (specialHoles.minDiameter > specialHoles.maxDiameter) {
          req.flag = true
          req.msg = this.$t('lineManager.diameterRange')
          req.ref = 'maxHolesWidth'
          return req
        }
        if (specialHoles.minDepth > specialHoles.maxDepth) {
          req.flag = true
          req.msg = this.$t('lineManager.hDeepRange')
          req.ref = 'maxHolesDepth'
          return req
        }
      }
      if (specialSlots.enable) {
        if (specialSlots.minWidth > specialSlots.maxWidth) {
          req.flag = true
          req.msg = this.$t('lineManager.widthRange')
          req.ref = 'maxSlotsWidth'
          return req
        }
        if (specialSlots.minDepth > specialSlots.maxDepth) {
          req.flag = true
          req.msg = this.$t('lineManager.sDeepRange')
          req.ref = 'maxSlotsDepth'
          return req
        }
      }
      return req
    },
    // 生成比较组合设备对应的form值
    genCombinedEquipmentSettingsForm(item, oriItem) {
      const currentCombinationEquipSettings = item.combinationEquip_settings
      const currentSpecialHoles = currentCombinationEquipSettings.specialHoles
      const currentSpecialSlots = currentCombinationEquipSettings.specialSlots
      const currentEngravingProcess =
        item.hole_slot_engraving_process.engraving_process_setting
      const currentShortEdgeRange =
        item.hole_slot_engraving_process.special_hole_slot.short_edge_range
      const currentLongEdgeRange =
        item.hole_slot_engraving_process.special_hole_slot.long_edge_range
      const currentRangeList =
        item.hole_slot_engraving_process.special_hole_slot.range_list

      // 生成current，只包含必要的参数
      const current = {
        firstEquipment: currentCombinationEquipSettings.firstEquipment,
        secondEquipment: currentCombinationEquipSettings.secondEquipment,
        specialHoles_enable: currentSpecialHoles.enable,
        specialHoles_diameter: [
          currentSpecialHoles.minDiameter,
          currentSpecialHoles.maxDiameter,
        ],
        specialHoles_deep: [
          currentSpecialHoles.minDepth,
          currentSpecialHoles.maxDepth,
        ],

        specialSlots_enable: currentSpecialSlots.enable,
        specialSlots_width: [
          currentSpecialSlots.minWidth,
          currentSpecialSlots.maxWidth,
        ],
        specialSlots_deep: [
          currentSpecialSlots.minDepth,
          currentSpecialSlots.maxDepth,
        ],
        allow_turn_plate_process:
          currentEngravingProcess.allow_turn_plate_process,
        dock56_drill_still_process:
          currentEngravingProcess.dock56_drill_still_process,
        special_shape_processing_in_dock56:
          currentEngravingProcess.special_shape_processing_in_dock56,
        non_hole_slot_of_special_shape:
          currentEngravingProcess.non_hole_slot_of_special_shape,
        curve_range_able: currentEngravingProcess.curve_range.curve_range_able,
        curve_max_size: currentEngravingProcess.curve_range.curve_max_size,
        short_edge_range: currentShortEdgeRange,
        long_edge_range: currentLongEdgeRange,
        range_list: [
          currentRangeList.short_edge_range,
          currentRangeList.long_edge_range,
          currentRangeList.connection,
          currentRangeList.long_condition,
          currentRangeList.short_condition,
        ],
        is_strentch_as_special_slot:
          currentEngravingProcess.is_strentch_as_special_slot,
        is_des_material_no_cut: item.is_des_material_no_cut,
        material_keywords_list: item.material_keywords_list,
        secondary_squaring: item.door_wall_aio_line_setting.secondary_squaring,
        slot_on_door_plank: item.door_wall_aio_line_setting.slot_on_door_plank,
      }
      const oriCombinationEquipSettings = oriItem.combinationEquip_settings
      const oriSpecialHoles = oriCombinationEquipSettings.specialHoles
      const oriSpecialSlots = oriCombinationEquipSettings.specialSlots
      const oriEngravingProcess =
        oriItem.hole_slot_engraving_process.engraving_process_setting
      const oriShortEdgeRange =
        oriItem.hole_slot_engraving_process.special_hole_slot.short_edge_range
      const oriLongEdgeRange =
        oriItem.hole_slot_engraving_process.special_hole_slot.long_edge_range
      const oriRangeList =
        oriItem.hole_slot_engraving_process.special_hole_slot.range_list
      // 生成ori，只包含必要的参数
      const ori = {
        firstEquipment: oriCombinationEquipSettings.firstEquipment,
        secondEquipment: oriCombinationEquipSettings.secondEquipment,
        specialHoles_enable: oriSpecialHoles.enable,
        specialHoles_diameter: [
          oriSpecialHoles.minDiameter,
          oriSpecialHoles.maxDiameter,
        ],
        specialHoles_deep: [oriSpecialHoles.minDepth, oriSpecialHoles.maxDepth],

        specialSlots_enable: oriSpecialSlots.enable,
        specialSlots_width: [
          oriSpecialSlots.minWidth,
          oriSpecialSlots.maxWidth,
        ],
        specialSlots_deep: [oriSpecialSlots.minDepth, oriSpecialSlots.maxDepth],
        allow_turn_plate_process: oriEngravingProcess.allow_turn_plate_process,
        dock56_drill_still_process:
          oriEngravingProcess.dock56_drill_still_process,
        special_shape_processing_in_dock56:
          oriEngravingProcess.special_shape_processing_in_dock56,
        non_hole_slot_of_special_shape:
          oriEngravingProcess.non_hole_slot_of_special_shape,
        curve_range_able: oriEngravingProcess.curve_range.curve_range_able,
        curve_max_size: oriEngravingProcess.curve_range.curve_max_size,
        short_edge_range: oriShortEdgeRange,
        long_edge_range: oriLongEdgeRange,
        range_list: [
          oriRangeList.short_edge_range,
          oriRangeList.long_edge_range,
          oriRangeList.connection,
          oriRangeList.long_condition,
          oriRangeList.short_condition,
        ],
        is_strentch_as_special_slot:
          oriEngravingProcess.is_strentch_as_special_slot,
        is_des_material_no_cut: oriItem.is_des_material_no_cut,
        material_keywords_list: oriItem.material_keywords_list,
        secondary_squaring:
          oriItem.door_wall_aio_line_setting.secondary_squaring,
        slot_on_door_plank:
          oriItem.door_wall_aio_line_setting.slot_on_door_plank,
      }
      return {
        current,
        ori,
      }
    },
    genCompareTableData(current, ori) {
      // debugger
      const newHoleList =
        current.hole_slot_engraving_process.engraving_holes_range
      const newAioHoleList = current.aio_hole_slot_process.aio_holes_range

      newHoleList.forEach((item, index) => {
        item.name = `单孔${index + 1}`
      })
      newAioHoleList.forEach((item, index) => {
        item.name = `单孔${index + 1}`
      })

      // 原始孔列表
      const oriHoleList = ori.hole_slot_engraving_process.engraving_holes_range
      const oriAioHoleList = ori.aio_hole_slot_process.aio_holes_range

      oriHoleList.forEach((item) => {
        item.name = `单孔${item.id + 1}`
      })
      oriAioHoleList.forEach((item) => {
        item.name = `单孔${item.id + 1}`
      })

      // 新的槽列表
      const newSlotList =
        current.hole_slot_engraving_process.engraving_slots_range
      const newAioSlotList = current.aio_hole_slot_process.aio_slots_range

      newSlotList.forEach((item, index) => {
        item.name = `单槽${index + 1}`
      })
      newAioSlotList.forEach((item, index) => {
        item.name = `单槽${index + 1}`
      })

      // 原始槽列表
      const oriSlotList = ori.hole_slot_engraving_process.engraving_slots_range
      const oriAioSlotList = ori.aio_hole_slot_process.aio_slots_range

      oriSlotList.forEach((item) => {
        // 给删除项确定名字
        item.name = `单槽${item.id + 1}`
      })
      oriAioSlotList.forEach((item) => {
        // 给删除项确定名字
        item.name = `单槽${item.id + 1}`
      })

      return {
        type: 'table',
        list: current.aio_hole_slot_process.enable_integration_device
          ? [...newAioHoleList, ...newAioSlotList]
          : [...newHoleList, ...newSlotList],
        oriList: current.aio_hole_slot_process.enable_integration_device
          ? [...oriAioHoleList, ...oriAioSlotList]
          : [...oriHoleList, ...oriSlotList],
        keys: [
          'minDepth',
          'maxDepth',
          'minDiameter',
          'maxDiameter',
          'minWidth',
          'maxWidth',
          'short_edge_range',
          'long_edge_range',
          'connection',
          'long_condition',
          'short_condition',
        ], // 列表要比较的keys
        tableType: operateRecordTableType.HOLE_SLOT_TABLE, // table 的 type
        key: '开料机设置-在开料机上加工的孔槽', // 表格对应的key
      }
    },
    genCompareFormData(current, ori) {
      // 开料设备对应的value值
      const activeCutEquipValueObj = {}
      current.cutList.forEach((child) => {
        activeCutEquipValueObj[child.value] = child.name
      })
      // 孔槽加工设备对应的value值
      const activeCureEquipValueObj = {}
      current.cureList.forEach((child) => {
        activeCureEquipValueObj[child.value] = child.name
      })
      // 开料机加工方式对应的value值
      const nowCureValueObj = {}
      this.cureCheckList.forEach((child) => {
        nowCureValueObj[child.value] = child.name
      })
      // 设备一和设备二对应的value值
      const equipValueObj = {}
      this.com_equipments.forEach((child) => {
        equipValueObj[child.value] = child.name
      })
      const equipValueObjCustomized = {
        engraving: '雕刻机',
        dock56FDrill: '五/六面钻',
        sideHoleDrill: '侧孔机',
        ptpHoleDrill: 'PTP',
        electronicSaw: '电子锯',
      }

      const compareMsg = [
        {
          title: '',
          keys: [
            'activeCutEquip',
            'activeCureEquip',
            'nowCure',
            'special_hole_slot',
            'special_hole_slot_way',
            'aio_hole_slot_shunt',
            'aio_hole_slot_shunt_way',
            // 'engraving_process_setting',
            'firstEquipment',
            'secondEquipment',
            'side_machine_hole_slot',
            'door_wall_aio',
            'secondary_squaring',
            'slot_on_door_plank',
          ],
        },
        {
          title: '设备一可加工孔槽范围',
          keys: [
            'specialHoles_enable',
            'specialHoles_diameter',
            'specialHoles_deep',
            'specialSlots_enable',
            'specialSlots_width',
            'specialSlots_deep',
          ],
        },
        {
          title: '开料机设置-加工设置',
          keys: [
            'non_hole_slot_of_special_shape',
            'dock56_drill_still_process',
            'special_shape_processing_in_dock56',
            'allow_turn_plate_process',
            'short_edge_range',
            'long_edge_range',
            'connection',
            'long_condition',
            'short_condition',
            'is_strentch_as_special_slot',
            'is_des_material_no_cut',
            'material_keywords_list',
            'curve_range_able',
            'curve_max_size',
          ],
        },
      ]

      return {
        type: 'form',
        current,
        ori,
        compareMsg,
        formTextObj: equipmentFormTextObj,
        formValueObj: {
          activeCutEquip: activeCutEquipValueObj,
          activeCureEquip: activeCureEquipValueObj,
          nowCure: nowCureValueObj,
          firstEquipment: equipValueObj,
          secondEquipment: equipValueObj,
          dock56_drill_still_process: {
            0: '不生成',
            1: '生成并加工',
            2: '生成但不加工',
          },
          special_shape_processing_in_dock56: {
            false: '不生成',
            true: '生成切割数据',
          },
          is_strentch_as_special_slot: {
            false: '普通槽',
            true: '特殊槽',
          },
          is_des_material_no_cut: {
            false: '关闭',
            true: '开启',
          },
          door_wall_aio: {
            false: '关闭',
            true: '开启',
          },
          secondary_squaring: {
            false: '关闭',
            true: '开启',
          },
          aio_hole_slot_shunt: {
            HINGESCREW: '铰链孔',
            HINGE: '铰链孔',
            HANGER: '衣通孔',
            STRENTCH: '拉直器槽',
            BP: '背板槽',
            ALS: '暗拉手槽',
            METAL: '门板金属条槽',
            DMBS: '抽屉金属条槽',
            in_range_all: '允许短边尺寸',
            KUCHOU: '裤抽孔',
            YXJ: '隐形件',
            LKYXJ: '乐扣槽',
            holes_in_yixing: '异形板上所有孔',
            slots_in_yixing: '异形板所有槽',
            bull_horn_handle: '牛角拉手',
            range_list: '允许短边尺寸',
            hole_slot_in_free_yixing: '自由异形板上所有孔槽',
          },
          aio_hole_slot_shunt_way: {
            ALS_way: '暗拉手槽',
            BP_way: '背板槽',
            DMBS_way: '抽屉金属条槽',
            METALINNER_way: '门板金属条槽',
            METAL_way: '门板金属条槽',
            MIDSTRENTCH_way: '拉直器槽',
            STRENTCHTWO_way: '拉直器槽',
            STRENTCH_way: '拉直器槽',
            aio_holes_range_way: '单孔',
            aio_slots_range_way: '单槽',
            gratingSlot_way: '格栅槽',
            normalSlot_way: '格栅槽',
          },
          side_machine_hole_slot: {
            HINGE: '铰链孔',
            STRENTCH: '拉直器槽',
            hinge_screw: '铰链门板引孔',
            preHole: '预埋孔',
            '3in1Lock': '偏心孔',
            ALS: '暗拉手槽',
            mill_info: '牛角拉手',
          },
        },
      }
    },
    // 生成最终的操作记录
    genFinalRecordFn(current, ori) {
      let recordData = {
        key: '', // 操作记录最外层的名字，比如：雕刻机
        operateArr: [
          // 应对多个操作页面时，比如雕刻机的操作页面
          {
            key: '',
            dataArr: [
              // 分为表单和table两种
              this.genCompareFormData(current, ori),
              this.genCompareTableData(current, ori),
            ],
          },
        ],
      }
      genFinalRecord(
        recordData,
        'equipment_docking',
        this.currentSaveLineId,
        () => {
          // 更新原始数据
          current.data.hole_slot_engraving_process.engraving_holes_range.forEach(
            (child, index) => {
              delete child.operate_type
              child.id = index
            }
          )
          current.data.hole_slot_engraving_process.engraving_slots_range.forEach(
            (child, index) => {
              delete child.operate_type
              child.id = index
            }
          )
          current.data.aio_hole_slot_process.aio_holes_range.forEach(
            (child, index) => {
              delete child.operate_type
              child.id = index
            }
          )
          current.data.aio_hole_slot_process.aio_slots_range.forEach(
            (child, index) => {
              delete child.operate_type
              child.id = index
            }
          )
          this.oriProduceLine = JSON.parse(JSON.stringify(this.produceLine))
        }
      )
    },

    genObjTrueValue(obj, type) {
      let keys = Object.keys(obj)
      const arr = []
      keys.forEach((key) => {
        if (obj[key] && keyName[type][key]) {
          arr.push(keyName[type][key])
        }
      })
      return arr
    },
    // 当前生产线 开料设备和孔槽设备的当前显示
    getCutCurShow(lineItem) {
      const cureObj = lineItem.cureList.find((item) => {
        if (item.show) {
          return item.value
        }
      })
      const cutObj = lineItem.cutList.find((item) => {
        if (item.show) {
          return item.value
        }
      })
      const cutCurshowArr = [cutObj.value, cureObj.value]
      return cutCurshowArr
    },

    genOperateRecord(action1, action2, res) {
      let recordData = {
        key: action1,
        operateArr: [
          {
            key: action2,
            dataArr: [
              {
                type: 'form',
                current: {
                  phone: res.data.phone,
                  time: new Date().toLocaleString(),
                  id: store.state.userInfo.id,
                  ip: res.data.request_ip,
                },
                ori: {
                  phone: '',
                  time: '',
                  id: '',
                  ip: '',
                },
                compareMsg: [
                  {
                    title: '',
                    keys: ['phone', 'time', 'id', 'ip'],
                  },
                ],
                formTextObj: {
                  phone: '手机号',
                  time: '保存时间',
                  id: '用户id',
                  ip: '物理地址',
                },
                formValueObj: {},
              },
            ],
          },
        ],
      }

      return recordData
    },
    handleAllBury(data, oriData) {
      // 开料机设置-加工方式
      buryPointApi('equipment_dock', `process_${data.nowCure}`)
      // 开料机设置-加工特殊孔槽
      Object.keys(data.hole_slot_engraving_process.special_hole_slot).forEach(
        (key) => {
          if (
            data.hole_slot_engraving_process.special_hole_slot[key] !=
              oriData.hole_slot_engraving_process.special_hole_slot[key] &&
            data.hole_slot_engraving_process.special_hole_slot[key]
          ) {
            buryPointApi('equipment_dock', key)
          }
        }
      )
      if (
        data.hole_slot_engraving_process.special_hole_slot.range_list.some(
          (item) => item.in_range_all
        )
      ) {
        buryPointApi('equipment_dock', 'min_size_filter')
      }
      if (
        data.hole_slot_engraving_process.engraving_holes_range.some(
          (item) =>
            item.maxDepth ||
            item.maxDiameter ||
            item.minDepth ||
            item.minDiameter
        )
      ) {
        buryPointApi('equipment_dock', 'single_hole_select')
      }
      if (
        data.hole_slot_engraving_process.engraving_slots_range.some(
          (item) =>
            item.maxDepth || item.maxWidth || item.minDepth || item.minWidth
        )
      ) {
        buryPointApi('equipment_dock', 'single_slot_select')
      }
      // 五六面钻设置
      const fiveSetKey = this.cuttingSettingOptions.find(
        (item) =>
          item.value ==
          data.hole_slot_engraving_process.engraving_process_setting
            .dock56_drill_still_process
      ).key
      buryPointApi('equipment_dock', `five_set_${fiveSetKey}`)
      const specialShapeProcess =
        data.hole_slot_engraving_process.engraving_process_setting
          .special_shape_processing_in_dock56
      buryPointApi(
        'equipment_dock',
        `special_shape_processing_in_dock56_${specialShapeProcess}`
      )
      buryPointApi(
        'equipment_dock',
        `five_set_specialSlot_${
          data.is_strentch_as_special_slot ? 'specialSlot' : 'normalSlot'
        }`
      )
      if (
        data.is_des_material_no_cut &&
        data.is_des_material_no_cut != oriData.is_des_material_no_cut
      ) {
        buryPointApi('equipment_dock', 'is_des_material_no_cut')
      }
      if (
        JSON.stringify(data.material_keywords_list) !=
        JSON.stringify(oriData.material_keywords_list)
      ) {
        buryPointApi('equipment_dock', 'material_keywords_list')
      }
      // 启用一体机后在雕刻机部分加工的特殊孔槽
      Object.keys(data.aio_hole_slot_process.aio_hole_slot_shunt).forEach(
        (key) => {
          if (data.aio_hole_slot_process.aio_hole_slot_shunt[key]) {
            buryPointApi('equipment_dock', `aio_${key}`)
          }
        }
      )
      if (
        data.aio_hole_slot_process.aio_holes_range.some(
          (item) =>
            item.maxDepth ||
            item.maxDiameter ||
            item.minDepth ||
            item.minDiameter
        )
      ) {
        buryPointApi('equipment_dock', 'aio_holes_range')
      }
      if (
        data.aio_hole_slot_process.aio_slots_range.some(
          (item) =>
            item.maxDepth || item.maxWidth || item.minDepth || item.minWidth
        )
      ) {
        buryPointApi('equipment_dock', 'aio_slots_range')
      }
      // 侧孔机设置
      Object.keys(data.side_machine_hole_slot).forEach((key) => {
        if (
          data.side_machine_hole_slot[key] &&
          data.side_machine_hole_slot[key] !=
            oriData.side_machine_hole_slot[key]
        ) {
          buryPointApi('equipment_dock', `side_machine_${key}`)
        }
      })
    },
    // 保存设置
    saveLine(item, lineIndex) {
      const dock56FDrillShow = item.cureList.find(
        (v) => v.value == 'fiveSix'
      ).show
      // 进行权限验证
      const selectEquipment = [
        {
          show: dock56FDrillShow,
          isVerifyPath: '/dockFiveSix',
        },
      ]
      const isPass = selectEquipment.some(
        (it) => it.show && !thirdPermission(it.isVerifyPath)
      )
      if (isPass) return
      //  ptp 保存时需要验证权限
      const ptpDrillShow = item.cureList.find((v) => v.value == 'ptp').show
      if (ptpDrillShow && !this.getIsPermission('ptp')) return
      this.currentSaveLineId = item.id
      // 组合设备时判断输入框值，最大值不能小于最小值
      if (item.activeCureEquip == 'combination') {
        let detectResult = this.detectComValue(item)
        if (detectResult.flag) {
          this.$message({
            message: this.$t('lineManager.inputCheck', {
              msg: detectResult.msg,
            }),
            type: 'error',
            duration: 2000,
          })
          this.$refs[detectResult.ref][0].focus()
          return
        }
      }
      // 如果保存的时候选择的是加工双面孔槽, 则清空正其余选项的设置
      if (
        item.nowCure == 'doubleHoleSlot' ||
        item.nowCure == 'DoubleHoleSlot'
      ) {
        item.cuttingSetting = []
      }
      let equip = ''
      item.cutList.forEach((v) => {
        if (v.value == 'engraving' && v.show == true) {
          equip = 'engraving'
        } else if (v.value == 'saw' && v.show == true) {
          equip = 'electronicSaw'
        } else if (v.value == 'glassEquip' && v.show == true) {
          equip = 'glassEquip'
        }
      })
      equip = equip ? equip : 'engraving'
      let obj = {
        STRENTCHTWO:
          item.hole_slot_engraving_process.special_hole_slot.STRENTCH,
        MIDSTRENTCH:
          item.hole_slot_engraving_process.special_hole_slot.STRENTCH,
        METALINNER: item.hole_slot_engraving_process.special_hole_slot.METAL,

        // 格栅前端使用的gratingSlot，后端要求再传入一个normalSlot字段与gratingSlot值相同
        normalSlot:
          item.hole_slot_engraving_process.special_hole_slot.gratingSlot,
      }
      item.hole_slot_engraving_process.special_hole_slot = Object.assign(
        item.hole_slot_engraving_process.special_hole_slot,
        obj
      )
      let wayObj = {
        STRENTCHTWO_way:
          item.hole_slot_engraving_process.special_hole_slot_way.STRENTCH_way,
        MIDSTRENTCH_way:
          item.hole_slot_engraving_process.special_hole_slot_way.STRENTCH_way,
        METALINNER_way:
          item.hole_slot_engraving_process.special_hole_slot_way.METAL_way,
        normalSlot_way:
          item.hole_slot_engraving_process.special_hole_slot_way
            .gratingSlot_way,
      }
      item.hole_slot_engraving_process.special_hole_slot_way = Object.assign(
        item.hole_slot_engraving_process.special_hole_slot_way,
        wayObj
      )

      let aioObj = {
        STRENTCHTWO: item.aio_hole_slot_process.aio_hole_slot_shunt.STRENTCH,
        MIDSTRENTCH: item.aio_hole_slot_process.aio_hole_slot_shunt.STRENTCH,
        METALINNER: item.aio_hole_slot_process.aio_hole_slot_shunt.METAL,

        // 格栅前端使用的gratingSlot，后端要求再传入一个normalSlot字段与gratingSlot值相同
        normalSlot: item.aio_hole_slot_process.aio_hole_slot_shunt.gratingSlot,
      }
      item.aio_hole_slot_process.aio_hole_slot_shunt = Object.assign(
        item.aio_hole_slot_process.aio_hole_slot_shunt,
        aioObj
      )
      let aiowayObj = {
        STRENTCHTWO_way:
          item.aio_hole_slot_process.aio_hole_slot_shunt_way.STRENTCH_way,
        MIDSTRENTCH_way:
          item.aio_hole_slot_process.aio_hole_slot_shunt_way.STRENTCH_way,
        METALINNER_way:
          item.aio_hole_slot_process.aio_hole_slot_shunt_way.METAL_way,
        normalSlot_way:
          item.aio_hole_slot_process.aio_hole_slot_shunt_way.gratingSlot_way,
      }
      item.aio_hole_slot_process.aio_hole_slot_shunt_way = Object.assign(
        item.aio_hole_slot_process.aio_hole_slot_shunt_way,
        aiowayObj
      )
      let equipments = [
        item.combinationEquip_settings.firstEquipment,
        item.combinationEquip_settings.secondEquipment,
      ]
      let data = {
        ...this.$store.state.saveInfo,
        setting_id: item.id + '',
        name: item.name,
        platform: 'bluen',
        settings: {
          dock6FDrill_partHole: item.cuttingSetting.includes(
            'dock6FDrill_partHole'
          ),
          dock56FDrill_partHole: item.cuttingSetting.includes(
            'dock56FDrill_partHole'
          ),
          dock56FDrill_partSlots: item.cuttingSetting.includes(
            'dock56FDrill_partSlots'
          ),
          dock56FDrill_partSlot: item.cuttingSetting.includes(
            'dock56FDrill_partSlot'
          ),
          dock56FDrill_excludeSlots: item.cuttingSetting.includes(
            'dock56FDrill_excludeSlots'
          ),
          cuttingEquipment: equip,
          side_machine_hole_slot: {
            HINGE: item.side_machine_hole_slot.HINGE,
            STRENTCH: item.side_machine_hole_slot.STRENTCH,
            horn_slot: item.side_machine_hole_slot.horn_slot,
            hinge_screw: item.side_machine_hole_slot.hinge_screw,
            preHole: item.side_machine_hole_slot.preHole,
            '3in1Lock': item.side_machine_hole_slot['3in1Lock'],
            ALS: item.side_machine_hole_slot.ALS,
            mill_info: item.side_machine_hole_slot.mill_info,
          },
          // dock5FDrill: item.cureList.find(v => v.value == "five").show,
          // dock6FDrill: item.cureList.find(v => v.value == "six").show,
          dock56FDrill: dock56FDrillShow,
          ncHoleSlot: item.nowCure,
          ptpHoleDrill: item.cureList.find((v) => v.value == 'ptp').show,
          sideHoleDrill: item.haveSetted
            ? item.cureList.find((v) => v.value == 'side').show
            : false,
          combinationEquip_settings: {
            ...item.combinationEquip_settings,
            // 如果当前用户是组合设备的定制用户
            special_user_combination_devices:
              this.isSpecialUserCombinedDevice ||
              this.isSpecialUserDoorWallCabinet,
          },
          combinationEquip:
            item.activeCureEquip == 'combination' ? true : false,
          hole_slot_engraving_process: item.hole_slot_engraving_process,
          aio_hole_slot_process: item.aio_hole_slot_process,
          new_engraving_set_flag:
            (item.cutList.find((item) => item.value == 'engraving').show &&
              (item.cureList.find((item) => item.value == 'fiveSix').show ||
                item.cureList.find((item) => item.value == 'ptp').show)) ||
            (item.cureList.find((item) => item.value == 'combination').show &&
              this.isSpecialUserCombinedDevice) ||
            (this.isSpecialUserDoorWallCabinet &&
              equipments.includes('door_wall_aio')),
          is_strentch_as_special_slot: item.is_strentch_as_special_slot,
          is_des_material_no_cut: item.is_des_material_no_cut,
          material_keywords_list: item.material_keywords_list,
        },
      }

      if (data.settings.combinationEquip) {
        // v2 用户无法保存组合设备
        if (this.userInfo.edition_id === 20) {
          this.$message({
            message:
              '<span id="equipment_line_combination_error">无组合设备使用权限</span>',
            dangerouslyUseHTMLString: true,
            type: 'error',
            duration: 1500,
            offset: 70,
          })
          return
        }
        if (equipments.includes('dock56FDrill')) {
          data.settings.dock56FDrill = true
        }
        if (equipments.includes('sideHoleDrill')) {
          data.settings.sideHoleDrill = true
        }
        if (equipments.includes('ptpHoleDrill')) {
          data.settings.ptpHoleDrill = true
        }
        if (equipments.includes('door_wall_aio')) {
          data.settings.door_wall_aio = true
        }

        data.settings.door_wall_aio_line_setting = {
          ...item.door_wall_aio_line_setting,
        }
        // 非定制用户
        if (
          equipments.includes('engraving') &&
          !this.isSpecialUserCombinedDevice
        ) {
          data.settings.cuttingEquipment = 'engraving'
        }
      }
      const [cut, cure] = this.getCutCurShow(item)
      if (
        data.settings.sideHoleDrill &&
        !(data.settings.dock56FDrill || data.settings.ptpHoleDrill)
      ) {
        if (cut === 'engraving' && item.nowCure == 'noHoleSlot') {
          this.$message({
            message:
              '<span id="equipment_line_side_hole_error">切换成侧孔机时, 开料机设置无法选择仅下料, 请确认!</span>',
            dangerouslyUseHTMLString: true,
            type: 'error',
            offset: 60,
          })
          return
        }
        if (cut === 'engraving' && item.nowCure == 'frontHoleSlot') {
          this.$message({
            message:
              '<span id="equipment_line_front_hole_error">切换成侧孔机时, 开料机设置无法选择加工正面孔槽, 请确认!</span>',
            dangerouslyUseHTMLString: true,
            type: 'error',
            offset: 60,
          })
          return
        }
      }

      this.showPageLoading = true
      this.$token('/save_production_line_setting', data, (res) => {
        if (res.status == 1) {
          this.isShowVisible = false
          this.$message({
            message: '<span id="equipment_line_save_success">保存成功</span>',
            dangerouslyUseHTMLString: true,
            type: 'success',
            duration: 1500,
            offset: 70,
          })
          let oriItem = this.oriProduceLine[lineIndex]
          this.oriItem = oriItem
          // 处理所有埋点
          this.handleAllBury(item, oriItem)
          //这如果返回了手机号和ip --- 添加操作记录
          if (res.data.phone && res.data.request_ip) {
            let recordData = this.genOperateRecord(
              '保存设置',
              '生产线设置',
              res
            )
            genFinalRecord(recordData, 'equipment_docking', '', () => {})
          }
          try {
            let combinedData = this.genCombinedEquipmentSettingsForm(
              item,
              oriItem
            )
            // 生成最后的操作记录
            this.genFinalRecordFn(
              {
                ...item,
                data: item,
                special_hole_slot: this.genObjTrueValue(
                  item?.hole_slot_engraving_process?.special_hole_slot,
                  'special_hole_slot'
                ), // 重新生成在开料机上加工的孔槽，转换成对应的显示值
                special_hole_slot_way:
                  item?.hole_slot_engraving_process?.special_hole_slot_way,
                aio_hole_slot_shunt:
                  item?.aio_hole_slot_process?.aio_hole_slot_shunt, // 重新生成在开料机上加工的孔槽，转换成对应的显示值
                aio_hole_slot_shunt_way:
                  item?.aio_hole_slot_process?.aio_hole_slot_shunt_way,
                engraving_process_setting: this.genObjTrueValue(
                  item?.hole_slot_engraving_process?.engraving_process_setting,
                  'engraving_process_setting'
                ), // 重新生成加工设置的孔槽，转换成对应的显示值
                ...combinedData.current,
              },
              {
                ...oriItem,
                data: oriItem,
                special_hole_slot: this.genObjTrueValue(
                  oriItem?.hole_slot_engraving_process?.special_hole_slot,
                  'special_hole_slot'
                ),
                special_hole_slot_way:
                  oriItem?.hole_slot_engraving_process?.special_hole_slot_way,
                aio_hole_slot_shunt:
                  oriItem?.aio_hole_slot_process?.aio_hole_slot_shunt, // 重新生成在开料机上加工的孔槽，转换成对应的显示值
                aio_hole_slot_shunt_way:
                  oriItem?.aio_hole_slot_process?.aio_hole_slot_shunt_way,
                engraving_process_setting: this.genObjTrueValue(
                  oriItem?.hole_slot_engraving_process
                    ?.engraving_process_setting,
                  'engraving_process_setting'
                ),
                ...combinedData.ori,
              }
            )
          } catch (error) {
            console.error('error', error)
          }
          // 刷新原始数据
          // this.refreshOriData()
        } else if (res.status == -1) {
          if (this.$store.state.saveInfo.phone) {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 1500,
              offset: 70,
            })
          }
          this.operateType = 'save'
          this.showSaveModal(item, lineIndex)
        } else {
          this.$message({
            message: `<span id="equipment_line_expire_error">${
              res?.msg || '身份信息已过期,请重新从柜柜打开此页面!'
            }</span>`,
            dangerouslyUseHTMLString: true,
            type: 'error',
            duration: 1500,
            offset: 70,
          })
        }
        store.commit('setSaveInfo', {})
        // 保存后删除不需要要显示的信息，避免显示错误
        Reflect.deleteProperty(
          item.hole_slot_engraving_process.special_hole_slot,
          'STRENTCHTWO'
        )
        Reflect.deleteProperty(
          item.hole_slot_engraving_process.special_hole_slot,
          'MIDSTRENTCH'
        )
        Reflect.deleteProperty(
          item.hole_slot_engraving_process.special_hole_slot,
          'METALINNER'
        )
      })
    },
    showSaveModal(item, lineIndex) {
      this.lockStatus = this.tempStatus
      this.verifyPassword = true
      this.currentItem = item
      this.currentLineIndex = lineIndex
      this.codeType = 'bluen_update_production'
      this.isShowVisible = true
      return
    },
    // 修改生产线名字
    modifyLineName(item, index) {
      this.lockStatus = this.tempStatus
      if (this.lockStatus === 1) {
        this.$message({
          message: `<span id="equipment_line_lock_error">${this.$t(
            'lineManager.lockTip'
          )}</span>`,
          dangerouslyUseHTMLString: true,
          type: 'error',
          duration: 1500,
          offset: 70,
        })
        return
      }
      this.currentProductLine = JSON.parse(JSON.stringify(item))
      // 允许修改默认生产线的名字
      // if (index == 0) {
      //   this.$message({
      //     type: 'info',
      //     message: this.$t('lineManager.reNameTip'),
      //     duration: 1000,
      //     offset: 70,
      //   })
      //   return
      // }
      this.nowLine = index
      this.$nextTick(() => {
        this.$refs.line_name[0].focus()
      })
    },
    // 确认修改名字
    confirmLineName(item, index) {
      const oriItem = this.oriProduceLine[index]
      if (this.isEditName) {
        this.nowLine = -1
        this.isEditName = false
        const update_params = {
          setting_id: item.id,
          name: item.name,
        }
        this.$token('/update_production_line_name', update_params, (res) => {
          if (res.status == 1) {
            this.$message({
              message: `<span id="equipment_line_edit_success">${this.$t(
                'common.editSuccess'
              )}</span>`,
              dangerouslyUseHTMLString: true,
              type: 'success',
              duration: 1500,
              offset: 70,
            })
            if (this?.currentProductLine?.name !== item.name) {
              this.saveDataJsonToOssForRecordFn(
                [
                  {
                    key: '重命名',
                    value: `${oriItem.name}->${item.name}`,
                  },
                ],
                { id: item.id, name: item.name }
              )
            }
            this.$store.commit('setCurrentProductLineName', item.name)
            // 刷新原始数据
            this.refreshOriData()

            // 重置状态, 防止下一次不会触发
            this.isEditName = true
          } else {
            this.$message({
              message: `<span id="equipment_line_permisson_error">${this.$t(
                'lineManager.permissonTip'
              )}</span>`,
              dangerouslyUseHTMLString: true,
              type: 'info',
              duration: 1500,
              offset: 70,
            })
          }
        })
      } else {
        this.isEditName = true
      }
    },
    // 删除生产线
    deleteLine(item) {
      this.lockStatus = this.tempStatus
      if (this.lockStatus === 1) {
        this.$message({
          message: `<span id="equipment_line_lock_error">${this.$t(
            'lineManager.lockTip'
          )}</span>`,
          dangerouslyUseHTMLString: true,
          type: 'error',
          duration: 1500,
          offset: 70,
        })
        return
      }
      this.showDeleteConfirm = true
      this.currentLine = item
    },
    cancelDelete() {
      this.showDeleteConfirm = false
    },

    confirmDelete() {
      this.$token(
        '/delete_production_line',
        {
          ...this.$store.state.saveInfo,
          platform: 'bluen',
          setting_id: this.currentLine.id,
        },
        (res) => {
          this.showDeleteConfirm = false
          this.isShowVisible = false
          if (res.status == 1) {
            this.$message({
              message: `<span id="equipment_line_delete_success">${this.$t(
                'common.deleteSuccess'
              )}</span>`,
              dangerouslyUseHTMLString: true,
              type: 'success',
              duration: 1500,
              offset: 70,
            })
            if (res.data.phone && res.data.request_ip) {
              let recordData = this.genOperateRecord(
                '设备对接',
                '删除生产线',
                res
              )
              genFinalRecord(recordData, 'equipment_docking', '', () => {})
            }
            this.saveDataJsonToOssForRecordFn(
              [
                {
                  key: '删除',
                  value: this.currentLine.name,
                },
              ],
              { id: this.currentLine.id, name: this.currentLine.name }
            )
            this.getProductList()
          } else if (res.status == -1) {
            if (this.$store.state.saveInfo.phone) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 1500,
                offset: 70,
              })
            }
            this.operateType = 'delete'
            this.showSaveModal(this.currentLine, this.currentLineIndex)
          } else {
            this.isShowVisible = false
            this.$message({
              message: `<span id="equipment_line_permisson_error">${
                res?.msg ?? this.$t('lineManager.permissonTip')
              }</span>`,
              dangerouslyUseHTMLString: true,
              type: 'info',
              duration: 1500,
              offset: 70,
            })
            store.commit('setSaveInfo', {})
          }
        }
      )
    },
    saveDataJsonToOssForRecordFn(record, option, cb) {
      saveDataJsonToOssForRecord(record, 'equipment_docking', option, cb)
    },
    scrollWarp(back) {
      this.$nextTick(() => {
        const element = this.$refs['breadCrumb']
        element.scrollTo({
          top: back ? 0 : element.scrollHeight,
          behavior: 'smooth',
        })
      })
    },
    // 添加生产线
    addNewLine() {
      // if(this.showTiangongPage){
      //   this.$message({
      //     message: '当前为免费版, 无法添加',
      //     type: 'info',
      //     duration: 1500,
      //     offset: 60
      //   })
      //   return
      // }
      // if(this.userInfo.edition_id != 5 && this.userInfo.edition_id != 6 && this.userInfo.edition_id != 12){
      //   this.$message({
      //     message: '暂无此权限, 请升级账号版本!',
      //     type: 'info',
      //   })
      //   return
      // }
      // if(this.userInfo.edition_id === 12 && this.produceLine.length === 4) {
      //   this.$message({
      //     message: '当前版本添加已达上限, 请升级账号版本!',
      //     type: 'info',
      //     duration: 1500,
      //     offset: 60
      //   })
      //   return
      // }
      this.lockStatus = this.tempStatus
      if (this.lockStatus === 1) {
        this.$message({
          message: `<span id="equipment_line_lock_error">${this.$t(
            'lineManager.lockTip'
          )}</span>`,
          dangerouslyUseHTMLString: true,
          type: 'error',
          duration: 1500,
          offset: 70,
        })
        return
      }
      let name = this.$t('lineManager.newLine', { idx: this.lineIndex })
      // 防止生产线名字重复
      let flag = false
      this.produceLine.forEach((v) => {
        if (v.name == name) {
          flag = true
        }
      })
      if (flag) {
        this.lineIndex++
        this.addNewLine()
        return
      }
      const newName = this.$t('lineManager.newLine', { idx: this.lineIndex })
      this.$token(
        '/create_production_line_setting',
        {
          name: newName,
        },
        (res) => {
          if (res.status == 1) {
            this.lineIndex++
            _hmt.push([
              '_trackEvent',
              '添加生产线',
              'click',
              '',
              this.lineIndex,
            ])
            this.saveDataJsonToOssForRecordFn([
              {
                key: '添加生产线',
                value: newName,
              },
            ])
            this.getProductList(null, true)
            this.$message({
              message: `<span id="equipment_line_format_success">${this.$t(
                'common.formatSuccess',
                { type: newName }
              )}</span>`,
              dangerouslyUseHTMLString: true,
              type: 'success',
              duration: 1500,
              offset: 60,
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 1500,
              offset: 60,
            })
          }
        }
      )
    },
    // 跳转柜柜试生产房间
    handleGoGuiguiTrail() {
      if (window.webToQt) {
        window.webToQt.openSampleRoom()
      }
    },
    // 添加孔槽
    addHoleSlot(item, key) {
      let obj
      if (
        (key == 'aio_holes_range' || key == 'aio_slots_range') &&
        !(item[key].length < 20)
      ) {
        this.$message.error('已达添加上限(20条)')
        return
      }
      if (key == 'engraving_holes_range' || key == 'aio_holes_range') {
        obj = {
          minDiameter: 0.0,
          maxDiameter: 0.0,
          minDepth: 0.0,
          maxDepth: 0.0,
          item_type: 'hole',
          [webId]: genUniId(),
        }
      } else {
        obj = {
          minWidth: 0.0,
          maxWidth: 0.0,
          minDepth: 0.0,
          maxDepth: 0.0,
          item_type: 'slot',
          [webId]: genUniId(),
        }
      }
      item[key].push(obj)
    },
    // 删除孔槽
    deleteHoleSlot(item, key, idx) {
      if (item[key].length <= 1) {
        return this.$message.error(this.$t('lineManager.deleteCheck'))
      }
      item[key].splice(idx, 1)
    },
    deleteHoleSlotRangeList(item, idx) {
      if (item.length <= 1) {
        return this.$message.error(this.$t('lineManager.deleteCheck'))
      }
      item.splice(idx, 1)
    },
    addHoleSlotRangeList(item) {
      if (item.length > 4) {
        return this.$message.error('已达添加上限(5条)')
      }
      item.push({
        in_range_all: false,
        long_edge_range: undefined,
        short_edge_range: 100,
        range_way: 'front_back',
        connection: 'and',
        long_condition: '<',
        short_condition: '<',
        range_type: 'hole_slot',
      })
    },
    getIsPermission(equipmentName) {
      let flag = true
      if (equipmentName == 'ptp' || equipmentName == 'combination') {
        if (![5, 6, 14, 19].includes(this.userInfo.edition_id)) {
          this.$message({
            message: `<span id="equipment_line_permisson_error">${this.$t(
              'lineManager.permissonErr'
            )}</span>`,
            dangerouslyUseHTMLString: true,
            type: 'info',
            duration: 1000,
            offset: 70,
          })
          flag = false
        }
      }
      if (
        this.userInfo.edition_id === 20 &&
        equipmentName === 'fiveSix' &&
        this.userInfo.annual_fee_expire
      ) {
        this.isVisiblExpire = this.userInfo.annual_fee_expire
        flag = false
      }
      return flag
    },
    // 显示开料机
    cureSetting(item) {
      item.showCure = !item.showCure
    },
    // 显示组合设备设置
    combinSeting(item) {
      const permission = this.getIsPermission('combination')
      if (!permission) return
      item.showCombin = !item.showCombin
    },
    // 前往开料机设置
    gotoSetting(val, line) {
      const { value } = val
      if (this.previewInfo.isApply) {
        line.id = this.previewInfo.settingId
      }
      let path = val.path
      if (this.previewInfo.isPreview) {
        path = val.previewPath
      }
      switch (value) {
        case 'engraving':
          buryPointApi('equipment_dock', 'engraving')
          break
        case 'saw':
          buryPointApi('equipment_dock', 'saw')
          break
        case 'glassEquip':
          buryPointApi('equipment_dock', 'glass')
          break
        case 'side':
          buryPointApi('equipment_dock', 'side_hole')
          break
        case 'fiveSix':
          buryPointApi('equipment_dock', 'five_six')
          break
        case 'ptp':
          buryPointApi('equipment_dock', 'ptp')
          break
      }
      this.$store.commit('setCurrentProductLineName', line.name)
      const permission = this.getIsPermission(val.value)
      if (!permission) return
      // 权限验证
      if (!thirdPermission(val.path)) return
      if (val.path == '') {
        this.$message({
          message: `<span id="equipment_line_deving">${this.$t(
            'lineManager.deving'
          )}</span>`,
          dangerouslyUseHTMLString: true,
          type: 'info',
          duration: 1000,
          offset: 70,
        })
        return
      } else if (val.path == 'current') {
        this.$message({
          message: `<span id="equipment_line_combin_tip">${this.$t(
            'lineManager.combinTip'
          )}</span>`,
          dangerouslyUseHTMLString: true,
          type: 'info',
          duration: 1500,
          offset: 70,
        })
        return
      } else {
        if (this.showTiangongPage) {
          this.$router.push(path)
        } else {
          if (val.type == 'cut') {
            _hmt.push(['_trackEvent', '开料设备选择', 'click', '', val.name])
          } else {
            _hmt.push([
              '_trackEvent',
              '孔槽加工设备选择',
              'click',
              '',
              val.name,
            ])
          }
          if (val.type !== 'cut' && line.haveSetted) {
            this.$router.push({
              path: path,
              query: {
                setting_id: line.id,
                line: line.name,
                equipType: val.value,
                isPreview: this.previewInfo.isPreview,
              },
            })
          } else if (val.type === 'cut') {
            this.$router.push({
              path: path,
              query: {
                setting_id: line.id,
                line: line.name,
                equipType: val.value,
                isPreview: this.previewInfo.isPreview,
              },
            })
          } else {
            this.$message({
              message: `<span id="equipment_line_no_use_equip">${this.$t(
                'lineManager.noUseEquip'
              )}</span>`,
              dangerouslyUseHTMLString: true,
              type: 'info',
              duration: 1500,
              offset: 70,
            })
          }
        }
      }
      // debugger
    },
    // 切换菜单
    async changeNowLineSetting(line, indexs, val, type, lineIndex) {
      line.haveSetted = true
      let index = indexs - 1
      // 切换开料设备
      if (type == 'cut') {
        // 若当前选择了组合设备，同时组合设备里选择了开料机 不包含定制用户
        if (
          line.activeCureEquip == 'combination' &&
          (line.combinationEquip_settings.firstEquipment == 'engraving' ||
            line.combinationEquip_settings.secondEquipment == 'engraving') &&
          !this.isSpecialUserCombinedDevice
        ) {
          this.$message({
            message: `<span id="equipment_line_equipment_select_tip">${this.$t(
              'lineManager.equipmentSelectTip'
            )}</span>`,
            dangerouslyUseHTMLString: true,
            type: 'warning',
            duration: 2000,
          })
          return
        }
        // 定制用户选择组合设备不允许切到玻璃切割机
        let idx = index
        if (val == 'last') {
          idx = index > 0 ? index - 1 : line.cutList.length - 1
        } else {
          idx = index === line.cutList.length - 1 ? 0 : index + 1
        }
        if (
          this.isSpecialUserCombinedDevice &&
          line.activeCureEquip == 'combination' &&
          line.cutList[idx].value == 'glassEquip'
        ) {
          this.$message({
            message: this.$t('lineManager.currentCombinationEquipment'),
            type: 'warning',
            duration: 2000,
          })
          return
        }
        try {
          // 当要将开料机切换成电子锯的时候需要校验权限
          const currentEquipment = line.cutList[idx]
          // 获取原始数据，之前选的开料设备是否是电子锯
          const oriEquipment = this.oriProduceLine[lineIndex].activeCutEquip
          // 只判断不在版本要求内的，其余的保存的时候后端进行判断
          if (
            // currentEquipment.value == 'saw' &&
            // oriEquipment !== 'saw' &&
            !this.authVersionIds.includes(this.userInfo.edition_id) &&
            currentEquipment.value == 'saw'
          ) {
            const params = {
              process_id: line.id,
              machine: 'electronic_saw',
              edition_id: this.$store.state.userInfo.edition_id,
              use_machine: oriEquipment == currentEquipment.value ? 1 : 0,
            }
            const res = await getEquipmentPermission(params)
            if (!res?.data?.can_use_num) {
              this.$message({
                type: 'info',
                message: this.translateUniform(
                  '您当前可使用的电子锯生产线条数已用完，如需增加，请联系销售！'
                ),
                duration: 1500,
                offset: 70,
              })
            }
          }
        } catch (error) {
          this.$message({
            type: 'info',
            message: this.translateUniform('获取设备权限失败！'),
            duration: 1500,
            offset: 70,
          })
          console.log(error, 'error')
        }
        for (let i = 0; i < line.cutList.length; i++) {
          line.cutList[i].show = false
        }
        if (val == 'last') {
          // 左箭头按钮
          // 如果是第一个就切换到最后一个, 如果不是则减一, 切换成上一个
          if (index > 0) {
            line.cutList[index - 1].show = true
          } else {
            line.cutList[line.cutList.length - 1].show = true
          }
        } else {
          // 右箭头按钮
          // 如果是最后一个则切换成第一个, 如果不是则切换成下一个
          if (index == line.cutList.length - 1) {
            line.cutList[0].show = true
          } else {
            line.cutList[index + 1].show = true
          }
        }
        // 记录选中的开料设备
        for (let i = 0; i < line.cutList.length; i++) {
          let item = line.cutList[i]
          if (item.show) {
            line.activeCutEquip = item.value
          }
        }
        // 判断是否为雕刻机, 如果是则显示开料机设置, 如果不是则不显示
        if (line.activeCutEquip == 'saw') {
          line.showExtraSetting = false
        } else {
          line.showExtraSetting = true
        }
      } else {
        line.cureList.forEach((v) => {
          v.show = false
        })
        if (val == 'last') {
          if (index > 0) {
            line.cureList[index - 1].show = true
          } else {
            line.cureList[line.cureList.length - 1].show = true
          }
        } else {
          if (index == line.cureList.length - 1) {
            line.cureList[0].show = true
          } else {
            line.cureList[index + 1].show = true
          }
        }
        // let flags = true
        // if(line.cureList[3].show == true){
        //   if(line.cureList[0].show == true){
        //     line.cureList[0].recombination = true
        //     flags = false
        //   }else if(line.cureList[1].show == true){
        //     line.cureList[1].recombination = true
        //     flags = false
        //   }else if(line.cureList[2].show == true){
        //     line.cureList[2].recombination =  true
        //     flags = false
        //   }
        // }
        line.cureList.forEach((v) => {
          v.recombination = v.show
        })
        // if(flags){
        // }
        // 记录选中的孔槽加工设置
        for (let i = 0; i < line.cureList.length; i++) {
          let item = line.cureList[i]
          // if(item.show && item.value == 'side'){
          //   line.nowCure =  'doubleHoleSlot'
          // }
          if (item.show) {
            line.activeCureEquip = item.value
          }
        }
        if (line.activeCureEquip != 'combination') {
          line.showCombinationSetting = false
        } else {
          line.showCombinationSetting = true
        }
      }
    },
    // 处理生产线数据
    dealLineData(
      justRefreshOriList,
      productionLineList = this.productLineList,
      isApply = false
    ) {
      // this.produceLine = []
      let temp = []
      productionLineList.forEach((v) => {
        // 处理孔槽自定义数据
        let arr = []
        if (v.data.dock6FDrill_partHole) {
          arr.push('dock6FDrill_partHole')
        }

        if (v.data.dock56FDrill_partHole) {
          arr.push('dock56FDrill_partHole')
        }
        if (v.data.dock56FDrill_partSlots) {
          arr.push('dock56FDrill_partSlots')
        }
        if (v.data.dock56FDrill_partSlot) {
          arr.push('dock56FDrill_partSlot')
        }
        if (v.data.dock56FDrill_excludeSlots) {
          arr.push('dock56FDrill_excludeSlots')
        }
        if (v.data.aio_hole_slot_process) {
          arr.push('aio_hole_slot_process')
        }
        let obj = {
          name: v.name,
          id: v.id,
          side_machine_hole_slot: v.data.side_machine_hole_slot,
          nowCure: v.data.ncHoleSlot,
          showNowCure: v.data.ncHoleSlot,
          showCure: false,
          showExtraSetting: v.data.cuttingEquipment == 'engraving',
          showCombinationSetting: v.data.combinationEquip
            ? v.data.combinationEquip
            : false,
          showCombin: false,
          cuttingSetting: arr,
          // activeCutEquip: v.data.cuttingEquipment == "electronicSaw" ? 'saw' : 'engraving',
          activeCutEquip:
            v.data.cuttingEquipment == 'electronicSaw'
              ? 'saw'
              : v.data.cuttingEquipment == 'engraving'
              ? 'engraving'
              : 'glassEquip',
          combinationEquip_settings: v.data.combinationEquip_settings,
          hole_slot_engraving_process: v.data.hole_slot_engraving_process,
          aio_hole_slot_process: v.data.aio_hole_slot_process,
          is_strentch_as_special_slot:
            v.data.is_strentch_as_special_slot ?? false,
          is_des_material_no_cut: v.data.is_des_material_no_cut ?? false,
          material_keywords_list: v.data.material_keywords_list ?? [],
          cutList: [
            {
              index: 1,
              name: 'common.electronicSaw',
              value: 'saw',
              img: 'assets/image/electronicSaw.svg',
              path: '/electronicSaw',
              previewPath: '/electronicSaw-preview',
              show: v.data.cuttingEquipment == 'electronicSaw',
              type: 'cut',
            },
            {
              index: 2,
              name: 'common.engraving',
              value: 'engraving',
              img: 'assets/image/materialMachine.svg',
              path: '/engraving',
              previewPath: '/engraving-preview',
              show: v.data.cuttingEquipment == 'engraving',
              type: 'cut',
            },
            {
              index: 3,
              name: 'common.glassEquip',
              value: 'glassEquip',
              img: 'assets/image/glassEquip.png',
              path: '/equipmentSetting',
              previewPath: '/equipmentSetting-preview',
              show: v.data.cuttingEquipment == 'glassEquip',
              type: 'cut',
            },
          ],
          cureList: [
            {
              index: 1,
              name: 'common.PTP',
              value: 'ptp',
              img: 'assets/image/ptpMachine.svg',
              path: '/bluenPtp',
              previewPath: '/bluenPtp-preview',
              show: v.data.combinationEquip ? false : v.data.ptpHoleDrill,
              recombination: false,
              type: 'cure',
            },
            {
              index: 2,
              name: 'common.FSDrill',
              value: 'fiveSix',
              img: 'assets/image/fiveFace.svg',
              path: '/dockFiveSix',
              previewPath: '/dockFiveSix-preview',
              show: v.data.combinationEquip ? false : v.data.dock56FDrill,
              recombination: false,
              type: 'cure',
            },
            {
              index: 3,
              name: 'common.sideHoleDrill',
              value: 'side',
              img: 'assets/image/sideHole.svg',
              path: '/sideHole',
              previewPath: '/sideHole-preview',
              show: v.data.combinationEquip ? false : v.data.sideHoleDrill,
              recombination: false,
            },
            {
              index: 4,
              name: 'common.combination',
              value: 'combination',
              img: 'assets/image/combinationEquip.png',
              path: 'current',
              previewPath: '/current-preview',
              show: v.data.combinationEquip,
              recombination: false,
              type: 'cure',
            },
          ],
          haveSetted:
            v.data.sideHoleDrill ||
            v.data.ptpHoleDrill ||
            v.data.dock56FDrill ||
            v.data.combinationEquip
              ? true
              : false,
          // sideHoleDrill: v.data.sideHoleDrill, //侧孔机
          // ptpHoleDrill: v.data.ptpHoleDrill, //ptp
          // dock56FDrill: v.data.dock56FDrill, //五六面钻
          // combinationEquip: v.data.combinationEquip, //组合设备

          door_wall_aio: v.data.door_wall_aio || false,
          door_wall_aio_line_setting: v.data.door_wall_aio_line_setting ?? {},
        }
        const range_list =
          obj.hole_slot_engraving_process.special_hole_slot.range_list
        const engraving_holes_range =
          obj.hole_slot_engraving_process.engraving_holes_range
        const aio_holes_range = obj.aio_hole_slot_process.aio_holes_range
        const engraving_slots_range =
          obj.hole_slot_engraving_process.engraving_slots_range
        const aio_slots_range = obj.aio_hole_slot_process.aio_slots_range
        if (range_list.length) {
          obj.hole_slot_engraving_process.special_hole_slot.range_list.forEach(
            (item) => {
              if (!Reflect.has(item, 'remark')) {
                item.remark = ''
              }
            }
          )
        }
        if (engraving_holes_range.length) {
          obj.hole_slot_engraving_process.engraving_holes_range.forEach(
            (item) => {
              if (!Reflect.has(item, 'remark')) {
                item.remark = ''
              }
            }
          )
        }
        if (aio_holes_range.length) {
          obj.aio_hole_slot_process.aio_holes_range.forEach((item) => {
            if (!Reflect.has(item, 'remark')) {
              item.remark = ''
            }
          })
        }
        if (engraving_slots_range.length) {
          obj.hole_slot_engraving_process.engraving_slots_range.forEach(
            (item) => {
              if (!Reflect.has(item, 'remark')) {
                item.remark = ''
              }
            }
          )
        }
        if (aio_slots_range.length) {
          obj.aio_hole_slot_process.aio_slots_range.forEach((item) => {
            if (!Reflect.has(item, 'remark')) {
              item.remark = ''
            }
          })
        }
        // 如果获取到的数据都为false, 则默认展示侧孔机
        let flag = true
        obj.cureList.forEach((v) => {
          if (v.show == true) {
            flag = false
          }
        })
        if (flag) {
          obj.cureList[2].show = true
          obj.cureList[2].recombination = true
        }
        // 如果同时选中了侧孔机和其他设备, 则展示其他设备, 否则展示侧孔机, 如果展示侧孔机, 则开料机设置选中双面孔槽
        if (obj.cureList[2].show) {
          if (obj.cureList[0].show == true) {
            obj.cureList[0].recombination = true
            obj.activeCureEquip = 'ptp'
          } else if (obj.cureList[1].show == true) {
            obj.activeCureEquip = 'fiveSix'
            obj.cureList[1].recombination = true
          } else {
            obj.cureList[2].recombination = obj.cureList[2].show
            obj.activeCureEquip = 'side'
          }
        } else {
          for (let i = 0; i < obj.cureList.length; i++) {
            obj.cureList[i].recombination = obj.cureList[i].show
            if (obj.cureList[i].recombination) {
              obj.activeCureEquip = obj.cureList[i].value
            }
          }
        }
        // debugger
        if (this.userInfo.edition_id == 4) {
          delete obj.cureList
          obj.nowCure = 'noHoleSlot'
        }
        // 删除加工孔槽不需要显示的属性
        Reflect.deleteProperty(
          obj.hole_slot_engraving_process.special_hole_slot,
          'STRENTCHTWO'
        )
        Reflect.deleteProperty(
          obj.hole_slot_engraving_process.special_hole_slot,
          'MIDSTRENTCH'
        )
        Reflect.deleteProperty(
          obj.hole_slot_engraving_process.special_hole_slot,
          'METALINNER'
        )
        // // 如果存在HINGESCREW字段则需要将字段修改成HINGE,后续HINGESCREW字段都会被覆盖
        // if (obj.hole_slot_engraving_process.special_hole_slot['HINGESCREW']) {
        //   obj.hole_slot_engraving_process.special_hole_slot['HINGE'] =
        //     obj.hole_slot_engraving_process.special_hole_slot['HINGESCREW']
        //   Reflect.deleteProperty(
        //     obj.hole_slot_engraving_process.special_hole_slot,
        //     'HINGESCREW'
        //   )
        // }

        // 孔槽数量为0 添加默认值
        if (!obj?.hole_slot_engraving_process?.engraving_holes_range?.length) {
          obj.hole_slot_engraving_process.engraving_holes_range = [
            {
              minDiameter: 0.0,
              maxDiameter: 0.0,
              minDepth: 0.0,
              maxDepth: 0.0,
              item_type: 'hole',
              id: 0,
              [webId]: genUniId(),
            },
          ]
        } else {
          // 如果有孔，给每条数据添加上id
          obj?.hole_slot_engraving_process?.engraving_holes_range.forEach(
            (item, index) => {
              item.id = index
              item[webId] = genUniId()
              item.item_type = 'hole'
            }
          )
        }
        if (!obj?.hole_slot_engraving_process?.engraving_slots_range?.length) {
          obj.hole_slot_engraving_process.engraving_slots_range = [
            {
              minWidth: 0.0,
              maxWidth: 0.0,
              minDepth: 0.0,
              maxDepth: 0.0,
              item_type: 'slot',
              id: 0,
              [webId]: genUniId(),
            },
          ]
        } else {
          obj?.hole_slot_engraving_process?.engraving_slots_range.forEach(
            (item, index) => {
              item.id = index
              item[webId] = genUniId()
              item.item_type = 'slot'
            }
          )
        }

        if (!obj?.aio_hole_slot_process?.aio_holes_range?.length) {
          obj.aio_hole_slot_process.aio_holes_range = [
            {
              minDiameter: 0.0,
              maxDiameter: 0.0,
              minDepth: 0.0,
              maxDepth: 0.0,
              item_type: 'hole',
              id: 0,
              [webId]: genUniId(),
            },
          ]
        } else {
          // 如果有孔，给每条数据添加上id
          obj?.aio_hole_slot_process?.aio_holes_range.forEach((item, index) => {
            item.id = index
            item[webId] = genUniId()
            item.item_type = 'hole'
          })
        }
        if (!obj?.aio_hole_slot_process?.aio_slots_range?.length) {
          obj.aio_hole_slot_process.aio_slots_range = [
            {
              minWidth: 0.0,
              maxWidth: 0.0,
              minDepth: 0.0,
              maxDepth: 0.0,
              item_type: 'slot',
              id: 0,
              [webId]: genUniId(),
            },
          ]
        } else {
          obj?.aio_hole_slot_process?.aio_slots_range.forEach((item, index) => {
            item.id = index
            item[webId] = genUniId()
            item.item_type = 'slot'
          })
        }

        // 开启一体机时开料机加工方式默认为加工板件正反面孔槽
        // 但是如果有一体机+五六面钻分流权限，则不设置为默认值
        if (
          obj?.aio_hole_slot_process.enable_integration_device &&
          !this.isAioAndDock56HoleSlotShuntAuth
        ) {
          obj.nowCure = 'doubleHoleSlot'
          obj.showNowCure = 'doubleHoleSlot'
        }

        // 需求改动，判断是否有格栅字段normalSlot,没有则为老用户，设置为默认值false
        if (
          obj.hole_slot_engraving_process?.special_hole_slot?.normalSlot ===
          undefined
        ) {
          obj.hole_slot_engraving_process.special_hole_slot.gratingSlot = false
        }
        temp.push(obj)
      })
      if (!justRefreshOriList) {
        this.produceLine = temp
      }
      if (!isApply) {
        this.oriProduceLine = JSON.parse(JSON.stringify(temp))
      }
    },
    // 刷新原始数据
    refreshOriData() {
      this.getProductList(true)
    },
    // 获取生产线列表
    getProductList(justRefreshOriList, isScroll) {
      this.isLoading = true
      this.$getByToken('/get_production_line_setting', '', async (res) => {
        if (res.status == 1) {
          // 导入时预览进入页面
          if (this.previewInfo.settingId) {
            res.data = res.data?.filter(
              (item) => item.id == this.previewInfo.settingId
            )
          }
          let templateData = cloneDeep(res.data)
          this.dealLineData(justRefreshOriList, templateData)
          // 应用生产线设置时，需要展示孔槽分流需要展示自己生产线的
          if (this.previewInfo.isApply) {
            res.data[0].data = this.previewProductLine.process.data
            this.dealLineData(false, res.data, true)
          }
          this.productLineList = res.data
          // 遍历生产线数据，调用获取权限的接口
          try {
            for (let i = 0; i < this.productLineList.length; ++i) {
              // 只要生产线当前的开料设备选择了电子锯，就需要调用1次
              const authLine = this.productLineList[i]
              if (authLine.data.cuttingEquipment === 'electronicSaw') {
                const params = {
                  process_id: authLine.id,
                  machine: 'electronic_saw',
                  edition_id: this.$store.state.userInfo.edition_id,
                  use_machine: 1,
                }
                await getEquipmentPermission(params)
              }
            }
          } catch (error) {
            console.log(error, 'error')
          }
          this.lineIndex = this.productLineList.length
          this.setProLineList(res.data)
          if (isScroll) this.scrollWarp()
          this.isLoading = false
        } else if (res.result) {
          this.$message({
            type: 'info',
            message: this.$t('lineManager.permissonTip'),
            duration: 1500,
            offset: 70,
          })
          this.isLoading = false
        }
      })
    },
    handleChangeWay(cure, lineIndex) {
      if (cure == 'frontHoleSlot') {
        let currentLine =
          this.produceLine[lineIndex].hole_slot_engraving_process
            .special_hole_slot_way
        let currentRangeList =
          this.produceLine[lineIndex].hole_slot_engraving_process
            .special_hole_slot.range_list
        for (let current in currentLine) {
          if (currentLine[current] == 'back') {
            currentLine[current] = 'front'
          }
        }
        currentRangeList.forEach((e) => {
          e.range_way == 'back' ? (e.range_way = 'front') : ''
        })
      }
    },
    // 显示天工
    showTiangong() {
      this.showTiangongPage = true
      this.produceLine = [
        {
          name: 'common.defaultProduction',
          id: 0,
          nowCure: 'doubleHoleSlot',
          showCure: false,
          showExtraSetting: true,
          cuttingSetting: [],
          activeCutEquip: 'engraving',
          activeCureEquip: 'side',
          cutList: [
            {
              index: 1,
              name: 'common.electronicSaw',
              value: 'saw',
              img: 'assets/image/electronicSaw.svg',
              path: '/electronicSaw?from=tiangong',
              show: false,
              type: 'cut',
            },
            {
              index: 2,
              name: 'common.engraving',
              value: 'engraving',
              img: 'assets/image/materialMachine.svg',
              path: '/engraving?from=tiangong',
              show: true,
              type: 'cut',
            },
          ],
          cureList: [
            {
              index: 1,
              name: 'common.PTP',
              value: 'ptp',
              img: 'assets/image/ptpMachine.svg',
              path: '/bluenPtp?from=tiangong',
              show: false,
              recombination: false,
              type: 'cure',
            },

            {
              index: 2,
              name: 'common.FSDrill',
              value: 'fiveSix',
              img: 'assets/image/fiveFace.svg',
              path: '/dockFiveSix?from=tiangong',
              show: false,
              recombination: false,
              type: 'cure',
            },
            {
              index: 3,
              name: 'common.sideHoleDrill',
              value: 'side',
              img: 'assets/image/sideHole.svg',
              path: '',
              show: true,
              recombination: true,
              type: 'cure',
            },
          ],
        },
      ]
    },

    handleHoleSlotChange(setItem, lineItem, isChangeWay = false) {
      if (isChangeWay) return
      // 铰链孔
      if (setItem.key == 'HINGESCREW') {
        lineItem.hole_slot_engraving_process.special_hole_slot['HINGE'] =
          lineItem.hole_slot_engraving_process.special_hole_slot['HINGESCREW']
      }
      if (
        (setItem.key === 'holes_in_yixing' ||
          setItem.key === 'slots_in_yixing' ||
          setItem.key === 'hole_slot_in_free_yixing') &&
        lineItem.activeCureEquip === 'fiveSix'
      ) {
        if (
          lineItem.hole_slot_engraving_process.special_hole_slot[setItem.key]
        ) {
          let dom = document.querySelector(
            `#toast_${setItem.key}_${lineItem.id}`
          )
          dom.style.display = 'block'
          if (setItem.key === 'holes_in_yixing') {
            dom.style.left = '-100px'
          }
          let timer = setTimeout(() => {
            dom.style.display = 'none'
            clearTimeout(timer)
          }, 4000)
        }
      }
    },

    handleOpenUnlock() {
      this.verifyPassword = false
      this.codeType = 'bluen_lock_production'
      this.isShowVisible = true
      this.lockStatus = this.tempStatus
    },
    handleGetLockStatus() {
      //TODO 进入页面，获取生产线设置锁的状态
      getLockStatus().then((res) => {
        // 拿到的锁状态赋值，当前是锁定还是解锁状态
        this.lockStatus = res?.data?.is_lock || 0
        this.tempStatus = res?.data?.is_lock || 0
      })
    },
    // 预览时，请求生产线数据
    async getProductListByUrl(jsonUrl, isApply = false) {
      this.isLoading = true
      try {
        const res = await getJsonUrlData(jsonUrl)
        if (res.status === 200) {
          this.$store.commit('equipEnvironment/setPreviewProductLine', res.data)
          if (!isApply) {
            this.productLineList = [res.data['process']]
            this.lineIndex = this.productLineList.length
            this.dealLineData(isApply)
            this.setProLineList([res.data['process']])
          }
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        this.isLoading = false
      }

      // axios({
      //   url: jsonUrl,
      // })
      //   .then((res) => {
      //     if (res.status === 200) {
      //       console.log(res.data)
      //       this.$store.commit(
      //         'equipEnvironment/setPreviewProductLine',
      //         res.data
      //       )
      //       this.productLineList = [res.data['process']]
      //       this.lineIndex = this.productLineList.length
      //       this.dealLineData(false)
      //       this.setProLineList([res.data['process']])
      //     }
      //   })
      //   .finally(() => {
      //     this.isLoading = false
      //   })
    },
    // 判断打孔设备1是否禁用
    isSecondEquipmentDisabled(value, line_item) {
      const { secondEquipment } = line_item.combinationEquip_settings
      return (
        secondEquipment === value ||
        (secondEquipment === 'ptpHoleDrill' && value === 'dock56FDrill') ||
        (secondEquipment === 'dock56FDrill' && value === 'ptpHoleDrill')
      )
    },
    // 判断打孔设备2是否禁用
    isThirdEquipmentDisabled(value, line_item) {
      const { firstEquipment } = line_item.combinationEquip_settings
      return (
        firstEquipment === value ||
        (firstEquipment === 'ptpHoleDrill' && value === 'dock56FDrill') ||
        (firstEquipment === 'dock56FDrill' && value === 'ptpHoleDrill')
      )
    },
    translateUniform(key) {
      return translateUniform(key)
    },
  },
  async mounted() {
    // 从后台点击应用时进入
    await this.fetchAioAndDock56HoleSlotShuntAuth()
    if (
      this.previewInfo.isPreview &&
      this.previewInfo.previewJsonUrl &&
      !this.previewInfo.isApply
    ) {
      this.getProductListByUrl(this.previewInfo.previewJsonUrl)
      return
    }
    if (this.previewInfo.isApply) {
      this.getProductListByUrl(this.previewInfo.previewJsonUrl, true)
      this.getProductList()
      return
    }
    if (window?.webToQt?.loadIndicatorHide) {
      window.webToQt.loadIndicatorHide()
    }
    if (window.sessionStorage.getItem('thinkerx_material')) {
      this.showNewProBtn = false
    }
    if (this.$route.query.from) {
      if (this.$route.query.from == 'tiangong') {
        this.showTiangong()
      }
    } else {
      this.showTiangongPage = false
      this.getProductList()
    }
    const breadCrumb = this.$refs['breadCrumb']
    const back = this.$refs['back']
    breadCrumb.addEventListener('scroll', (e) => {
      const { scrollTop } = e.target
      if (scrollTop > 350) {
        back.style.right = '80px'
      } else {
        back.style.right = '-80px'
      }
    })
    if (
      JSON.parse(window.sessionStorage.getItem('guiguiJumpEquipmentParams'))
        ?.guigui_equipment === '1'
    ) {
      buryPointApi('guigui', 'jumpEquipment')
    }
    const navigate = Navigate.getInstance()
    navigate.registerEvent(this.$route.path, {
      waitLoadDone: () => (this.isLoading ? 0 : 1),
      openEngravingSetting: () => {
        const { line_id } =
          SearchRegistry.getInstance().getDynamicParams('/equipment')
        const target = this.produceLine.find(
          (item) => item.id === Number(line_id)
        )
        if (!target) return
        // 让此生产线的功能显示出来便于后续搜索的定位
        target.showCure = true
      },
      openCombinSetting: () => {
        const { line_id } =
          SearchRegistry.getInstance().getDynamicParams('/equipment')
        const target = this.produceLine.find(
          (item) => item.id === Number(line_id)
        )
        if (!target) return
        // 让此生产线的功能显示出来便于后续搜索的定位
        target.showCombin = true
      },
    })
  },
  created() {
    this.handleGetLockStatus()
    if (this.$route.query.guigui_token) {
      window.sessionStorage.setItem('first', 1)
      if (!window.localStorage.getItem('debugger')) {
        window.history.replaceState('', '', '#' + this.$route.path)
      }
    }
  },
  beforeDestroy() {
    Navigate.getInstance().unregisterEvent('/equipment')
  },
  components: {
    GBaseModal,
    MLockModal,
    MSettingOptions,
    GQrcodeAuthentication,
  },
}
</script>

<style scoped lang="less">
.bread-crumb {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow-y: scroll;

  span {
    cursor: default;
  }

  .trail-mark {
    top: -15px;
    right: -20px;
    z-index: 1;
    width: 55px;
    height: 25px;
    line-height: 27px;
    background-color: #0063ff;
    transform: scale(0.8);
  }

  .back {
    position: fixed;
    right: -80px;
    bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    color: #fff;
    background-color: #18a8c7;
    border-radius: 50%;
    transition: all 0.5s;

    .anticon-arrow-up {
      font-size: 2rem;
    }

    span {
      font-size: 12px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .wrap {
    box-sizing: border-box;
    width: 1136px;
    min-height: calc(100vh - 84px);
    margin: 0 auto;
    padding-bottom: 30px;
    .tip {
      color: red;
    }
    .add-produce-line {
      margin: 24px 0 0;
      justify-content: space-between;
      .lock-icon {
        font-size: 30px;
        .anticon {
          display: block;
        }
      }
    }

    .produce-line {
      width: 100%;
      margin-top: 107px;

      .produce-setting {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .line-name {
          display: inline-block;
          margin-bottom: 16px;
          color: #8c8c8c;
          font-size: 20px;
        }

        .ant-input {
          width: 200px;
          // height: 20px;
          margin-bottom: 16px;
        }

        .produce-line-icon {
          display: flex;
          align-items: center;

          .anticon {
            margin-right: 32px;
            color: #fff;
            font-size: 15px;
            cursor: pointer;
          }

          .ant-btn {
            margin-right: 8px;

            &:last-child {
              margin-right: 0;
              color: #fff;
              background: #18a8c7;
            }
          }
        }
      }

      .content {
        position: relative;
        width: 100%;
        height: 107px;
        background: #e3e3e3;
        border-radius: 6px 6px 0 0;

        & > div {
          position: absolute;
          top: -76px;
          left: 255px;
          display: flex;

          .cutting {
            margin-right: 110px;
          }

          .common-setting {
            position: relative;
            display: flex;
            align-items: center;
            user-select: none;

            .common-setting-title {
              position: absolute;
              top: -43px;
              left: 50%;
              display: inline-block;
              width: 100%;
              color: #000;
              font-weight: 500;
              font-size: 20px;
              font-family: PingFangSC-Medium, 'PingFang SC';
              text-align: center;
              transform: translateX(-50%);
            }

            .common-content {
              width: 152px;
              height: 152px;
              margin: 0 22px;
              text-align: center;
              background: #fff;
              border-radius: 8px;
              border: 1px solid;
              cursor: pointer;
              transition: all 0.5s;

              &:hover {
                box-shadow: 0 6px 18px 0 rgba(0, 0, 0, 0.09);
              }

              &:active {
                box-shadow: 0 6px 18px 0 rgba(0, 0, 0, 0.09);
              }

              & > div {
                width: 76px;
                height: 76px;
                margin: 16px auto;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              span {
                color: #5a5a5a;
                line-height: 22px;

                &::after {
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  display: block;
                  width: 21px;
                  height: 5px;
                  margin: 0 auto;
                  background: #18a8c7;
                  content: '';
                }
              }
            }

            .anticon {
              font-size: 20px;
              cursor: pointer;
            }
          }
        }
      }

      .cutting-setting {
        .cutting-setting-title {
          height: 48px;
          padding-left: 19px;
          line-height: 48px;
          background: #dadada;
          cursor: pointer;

          span {
            color: #5c5c5c;
            font-weight: 500;
          }
        }
      }
      .cutting-checkbox {
        box-sizing: border-box;
        padding: 24px;
        border: 2px solid #eee;
        border-top: none;
        background: #fff;
        // display: flex;
        // align-items: flex-start;
        // .cure-setting{
        //   .ant-radio-group{
        //     display: flex;
        //     flex-direction: column;
        //     label{
        //       margin-bottom: 32px;
        //       font-size: 15px;
        //       &:last-child{
        //         margin-bottom: 0px;
        //       }
        //     }
        //   }
        // }
        .cure-setting-box {
          .cure-label {
            flex-shrink: 0;
          }
          .cure-box {
            border: 2px solid gainsboro;
            // /deep/ .ant-radio-wrapper {
            //   display: flex;
            //   justify-items: center;
            // }

            .slot {
              margin-top: 15px;
            }

            .hole {
              margin-top: 15px;
            }
            .aio-tip {
              color: #18a8c7;
            }
            .aio-item {
              margin-left: 90px;
            }

            .hole-slot {
              display: flex;
              align-items: center;
              margin-left: 50px;

              .el-input {
                width: 60px;
              }

              > div {
                margin-left: 20px;
              }

              .add {
                margin-left: 20px;
                color: blue;
                cursor: pointer;
              }

              .delete {
                margin-left: 20px;
                color: red;
                cursor: pointer;
              }
            }

            label {
              font-size: 15px;
            }
            .hole-slot_setting {
              .ant-checkbox-wrapper + .ant-checkbox-wrapper {
                margin-left: 0;
              }
              .ant-checkbox-wrapper:nth-child(n + 7) {
                margin-top: 10px;
              }
              .tick-box {
                /deep/ .ant-checkbox + span {
                  padding-right: 0;
                }
              }
              .specialPlank {
                margin-right: 20px;
              }
            }
          }
          .hole-slot-setting {
            display: flex;
            align-items: center;
            margin-top: -6px;
            &_option {
              position: relative;
              margin-right: 30px;
              /deep/.ant-checkbox + span {
                padding-right: 0;
              }
              .warning-tip {
                position: absolute;
                bottom: -13px;
                left: 610px;
                color: red;
              }
              .setting-option-select {
                width: 120px;
                height: 28px;
                /deep/ .ant-select-selection--single {
                  height: 28px;
                  .ant-select-selection__rendered {
                    margin-left: 5px;
                    line-height: 28px;
                  }
                }
              }
            }
          }
          .short-side-setting {
            position: relative;
            margin-bottom: 25px;
            :deep(.ant-checkbox + span) {
              padding-right: 0;
            }
            .el-input {
              width: 75px;
            }
            .add {
              margin-left: 20px;
              color: blue;
              cursor: pointer;
            }

            .delete {
              margin-left: 20px;
              color: red;
              cursor: pointer;
            }
            .add-delete {
              position: absolute;
              right: 10px;
            }
          }
        }
      }
      .combination_setting {
        .choose_equipment_setting_btn {
          display: inline-block;
          margin-left: 10px;
          color: rgb(24, 168, 199);
          cursor: pointer;
          user-select: none;
        }
        .combination_setting_title {
          height: 48px;
          padding-left: 19px;
          line-height: 48px;
          background: #dadada;
          cursor: pointer;

          span {
            color: #5c5c5c;
            font-weight: 500;
            cursor: pointer;
            user-select: none;
          }
        }

        .combination_setting_box {
          padding: 22px 8px 25px;
          background-color: #fff;

          .choose_equipment_box {
            display: flex;
            justify-content: space-between;
            padding: 0 16px;
            border-bottom: 1px solid rgb(233, 233, 233);
            .choose_equipment {
              // display: flex;
              align-items: center;

              > span {
                display: inline-block;
                margin: 0 24px;
              }

              > img {
                width: 16px;
                height: 16px;
                margin-left: 24px;
                cursor: pointer;
              }
            }

            .choose_equipment_msg {
              width: 219px;
              height: 35px;
              margin: 22px 0 20px;
              padding-left: 24px;
              color: rgb(243, 101, 65);
              font-size: 12px;
              line-height: 35px;
              background: #fff5f5;
            }
            .guidance-prompt {
              width: 446px;
              height: 190px;
              flex-shrink: 0;
              border-radius: 4px;
              background: #f4f9fa;
              padding: 20px 16px;
              position: relative;
              // 设置对角边框
              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(to left, #18a8c7, #18a8c7) left top
                    no-repeat,
                  linear-gradient(to bottom, #18a8c7, #18a8c7) left top
                    no-repeat,
                  linear-gradient(to left, #18a8c7, #18a8c7) right bottom
                    no-repeat,
                  linear-gradient(to left, #18a8c7, #18a8c7) right bottom
                    no-repeat;

                /*设置大小*/
                background-size: 2px 20px, 20px 2px;
                border-radius: 4px;
              }
              .service-img {
                height: 20px;
                width: 20px;
              }
              .example {
                display: flex;
                flex-direction: column;
                margin-left: 3px;
              }
            }
          }

          .equipment_setting {
            padding: 0 24px;

            .equipment_setting_title {
              padding: 20px 0;
              font-weight: bold;
              font-size: 16px;
            }

            .holes_slots_setting {
              display: flex;
              align-items: center;
              margin-bottom: 15px;

              > div {
                margin-right: 30px;
              }
            }

            .choose_equipment_msg {
              width: 633px;
              height: 35px;
              margin-top: 22px;
              padding-left: 24px;
              color: rgb(243, 101, 65);
              font-size: 12px;
              line-height: 35px;
              background: #fff5f5;
            }
          }
        }
      }
    }
  }

  .confirm-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);

    .content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 3;
      box-sizing: border-box;
      width: 400px;
      height: 200px;
      margin: auto;
      padding: 24px;
      background: #fff;
      border-radius: 8px;

      .dialog-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #000;
        font-weight: 600;
        font-size: 18px;
      }

      .dialog-content {
        margin-top: 24px;
        color: #000;
        font-size: 16px;

        span {
          display: inline-block;
          text-indent: 2em;
        }
      }

      .dialog-operation {
        position: absolute;
        bottom: 24px;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        width: 100%;
        padding: 0 24px;
      }
    }
  }
  .tick-box {
    display: inline-block;
  }
  .toast-message {
    background-color: rgb(255, 213, 220);
    color: red;
    width: 230px;
    text-align: center;
    border-radius: 5px;
    z-index: 999;
    top: -25px;
    left: -20px;
    display: none;
    line-height: 22px;
  }
  .special-way {
    width: 94px;
    margin-right: 24px;
  }
  .path-flag {
    align-items: center;
    .path-shap {
      margin-left: 40px;
      :deep(.ant-checkbox + span) {
        padding-right: 0;
      }
    }
  }
}
</style>
